{
  "level": "q301",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q301",
    "objects": "AREAS.E3:q301.e3",
    "mesh": "TREES.E3:q301.e3"
  },
  "spawn_point": {
    "position": [
      640.6440339350836,
      736.2046585806859,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      640.6440339350836,
      836.2046585806859,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1062.5450439453125,
      -2563.9130859375,
      -300.0
    ],
    "bbox_max": [
      2754.851318359375,
      1830.0,
      1443.904296875
    ],
    "vertex_count": 1054,
    "vertices": [
      [
        1031.88916015625,
        478.11090087890625,
        -300.0
      ],
      [
        2754.851318359375,
        -1244.851318359375,
        -300.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1030.0,
        960.0,
        380.0
      ],
      [
        1037.0,
        960.0,
        580.0
      ],
      [
        1235.0,
        1050.0,
        118.0
      ],
      [
        1215.0,
        1050.0,
        118.0
      ],
      [
        1215.0,
        1050.0,
        120.0
      ],
      [
        1215.0,
        1050.0,
        118.0
      ],
      [
        1044.56787109375,
        1072.43212890625,
        796.2268676757812
      ],
      [
        1042.949951171875,
        1074.050048828125,
        750.0
      ],
      [
        1030.0,
        975.0,
        255.0
      ],
      [
        1235.0,
        960.0,
        118.0
      ],
      [
        1215.0,
        960.0,
        118.0
      ],
      [
        1215.0,
        960.0,
        120.0
      ],
      [
        1215.0,
        960.0,
        118.0
      ],
      [
        1157.0,
        960.0,
        750.0
      ],
      [
        1157.0,
        960.0,
        800.6990966796875
      ],
      [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      [
        1044.5675048828125,
        977.5806884765625,
        796.2144165039062
      ],
      [
        1037.0,
        960.0,
        750.0
      ],
      [
        1037.0,
        960.0,
        808.5314331054688
      ],
      [
        1037.0,
        960.0,
        580.0
      ],
      [
        1037.0,
        960.0,
        750.0
      ],
      [
        1030.0,
        940.0,
        130.0
      ],
      [
        1235.0,
        939.52001953125,
        118.0
      ],
      [
        1215.0,
        939.52001953125,
        118.0
      ],
      [
        1215.0,
        939.5999755859375,
        120.0
      ],
      [
        1215.0,
        939.52001953125,
        118.0
      ],
      [
        1037.0,
        958.0,
        580.0
      ],
      [
        1037.0,
        958.0,
        580.0
      ],
      [
        1037.0,
        960.0,
        630.0003662109375
      ],
      [
        1030.0,
        930.0,
        130.0
      ],
      [
        1168.0,
        930.0,
        80.0
      ],
      [
        1200.0,
        926.0,
        80.0
      ],
      [
        1171.9998779296875,
        926.0,
        80.0
      ],
      [
        1235.0,
        929.0399780273438,
        118.0
      ],
      [
        1215.0,
        929.0399780273438,
        118.0
      ],
      [
        1215.0,
        929.199951171875,
        120.0
      ],
      [
        1215.0,
        929.0399780273438,
        118.0
      ],
      [
        1030.0,
        926.0,
        80.0
      ],
      [
        1030.0,
        930.0,
        80.0
      ],
      [
        1037.0,
        960.0,
        665.71533203125
      ],
      [
        1030.0,
        880.0,
        80.0
      ],
      [
        1214.53955078125,
        720.0,
        80.0
      ],
      [
        1230.0,
        720.0,
        80.0
      ],
      [
        1215.0,
        720.0,
        120.0
      ],
      [
        1235.0,
        720.0,
        120.0
      ],
      [
        1060.0,
        720.0,
        120.0
      ],
      [
        1190.0,
        720.0,
        120.0
      ],
      [
        1235.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        720.0,
        120.0
      ],
      [
        1215.0,
        720.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        120.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        1030.0,
        867.8525390625,
        170.0
      ],
      [
        1030.0,
        825.0,
        170.0
      ],
      [
        1060.0,
        720.0,
        170.0
      ],
      [
        1030.0,
        720.0,
        170.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1150.0,
        747.730224609375,
        170.0
      ],
      [
        1100.0,
        785.0,
        170.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1171.0,
        720.0,
        195.0
      ],
      [
        1079.0,
        720.0,
        195.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1077.730224609375,
        720.0,
        200.0
      ],
      [
        1077.730224609375,
        720.0,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1077.730224609375,
        720.0,
        200.0
      ],
      [
        1077.730224609375,
        720.0,
        195.0
      ],
      [
        1156.9326171875,
        720.0,
        180.0
      ],
      [
        1172.269775390625,
        720.0,
        180.0
      ],
      [
        1093.0673828125,
        720.0,
        180.0
      ],
      [
        1077.730224609375,
        720.0,
        180.0
      ],
      [
        1156.9326171875,
        720.0,
        180.0
      ],
      [
        1093.0673828125,
        720.0,
        180.0
      ],
      [
        1077.730224609375,
        720.0,
        190.0
      ],
      [
        1077.730224609375,
        720.0,
        180.0
      ],
      [
        1171.0,
        720.0,
        190.0
      ],
      [
        1171.0,
        720.0,
        195.0
      ],
      [
        1172.269775390625,
        720.0,
        190.0
      ],
      [
        1171.0,
        720.0,
        190.0
      ],
      [
        1030.0,
        650.0,
        60.0
      ],
      [
        1030.0,
        700.0,
        60.0
      ],
      [
        1265.0,
        720.0,
        79.99999237060547
      ],
      [
        1265.0,
        620.0,
        80.0
      ],
      [
        1210.0,
        707.730224609375,
        120.0
      ],
      [
        1210.0,
        687.730224609375,
        120.0
      ],
      [
        1030.0,
        650.0,
        60.0
      ],
      [
        1030.0,
        640.0,
        80.0
      ],
      [
        1114.72705078125,
        395.27288818359375,
        150.0
      ],
      [
        1114.72705078125,
        395.27288818359375,
        60.0
      ],
      [
        1030.0,
        700.0,
        60.0
      ],
      [
        1030.0,
        707.730224609375,
        80.98199462890625
      ],
      [
        1030.0,
        707.730224609375,
        120.0
      ],
      [
        1030.0,
        707.730224609375,
        170.0
      ],
      [
        1030.0,
        707.730224609375,
        120.0
      ],
      [
        1030.0,
        707.730224609375,
        80.98199462890625
      ],
      [
        1090.0,
        707.730224609375,
        195.0
      ],
      [
        1077.730224609375,
        720.0,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        195.0
      ],
      [
        1077.730224609375,
        720.0,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        190.0
      ],
      [
        1077.730224609375,
        720.0,
        190.0
      ],
      [
        1030.0,
        707.730224609375,
        170.0
      ],
      [
        1040.0,
        687.730224609375,
        118.0
      ],
      [
        1040.0,
        687.730224609375,
        120.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1036.0,
        640.0,
        118.0
      ],
      [
        1030.0,
        660.0,
        100.0
      ],
      [
        1030.0,
        680.0,
        100.0
      ],
      [
        1030.0,
        660.0,
        100.0
      ],
      [
        1030.0,
        660.0,
        98.0
      ],
      [
        1030.0,
        650.0,
        115.0
      ],
      [
        1030.0,
        640.0,
        115.0
      ],
      [
        1030.0,
        1031.2564697265625,
        380.0
      ],
      [
        1020.0,
        1027.4595947265625,
        130.0
      ],
      [
        852.8232421875,
        1199.403564453125,
        320.0
      ],
      [
        852.8232421875,
        1199.403564453125,
        140.0
      ],
      [
        816.943115234375,
        1120.0,
        110.0
      ],
      [
        950.0,
        1000.8809204101562,
        110.0
      ],
      [
        868.6691284179688,
        970.0,
        110.0
      ],
      [
        861.3308715820312,
        970.0,
        110.0
      ],
      [
        807.7501831054688,
        990.3442993164062,
        110.0
      ],
      [
        783.0528564453125,
        1045.0,
        110.0
      ],
      [
        960.0,
        1004.6778564453125,
        80.0
      ],
      [
        1010.0,
        1023.66259765625,
        80.0
      ],
      [
        868.6691284179688,
        970.0,
        80.0
      ],
      [
        868.6691284179688,
        970.0,
        69.85213470458984
      ],
      [
        861.3308715820312,
        970.0,
        69.0367660522461
      ],
      [
        861.3308715820312,
        970.0,
        80.0
      ],
      [
        861.3308715820312,
        970.0,
        69.03675842285156
      ],
      [
        868.669189453125,
        970.0,
        69.85212707519531
      ],
      [
        865.0,
        968.6068725585938,
        69.44444274902344
      ],
      [
        1010.0,
        1023.66259765625,
        110.0
      ],
      [
        1010.0,
        1023.66259765625,
        80.0
      ],
      [
        1010.0,
        1120.0,
        110.0
      ],
      [
        861.3308715820312,
        970.0,
        110.0
      ],
      [
        868.669189453125,
        970.0,
        110.0
      ],
      [
        980.0,
        1012.2717895507812,
        118.0
      ],
      [
        980.0,
        1012.2717895507812,
        120.0
      ],
      [
        980.0,
        1012.2717895507812,
        118.0
      ],
      [
        1000.0,
        1019.8656616210938,
        118.0
      ],
      [
        1010.0,
        1023.66259765625,
        130.0
      ],
      [
        1010.0,
        1023.66259765625,
        118.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1020.0,
        1027.4595947265625,
        145.0
      ],
      [
        1010.0,
        1023.66259765625,
        130.0
      ],
      [
        885.0,
        1081.7095947265625,
        170.0
      ],
      [
        885.0,
        1113.79931640625,
        170.0
      ],
      [
        885.0,
        1008.29052734375,
        170.0
      ],
      [
        885.0,
        976.2007446289062,
        170.0
      ],
      [
        804.9999389648438,
        1045.0,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        822.5736694335938,
        1083.890869140625,
        170.0
      ],
      [
        804.9999389648438,
        1045.0,
        170.0
      ],
      [
        834.24267578125,
        1109.7147216796875,
        170.0
      ],
      [
        822.5736694335938,
        1083.890869140625,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        865.0,
        990.0,
        170.0
      ],
      [
        865.0,
        990.0,
        170.0
      ],
      [
        885.0,
        982.4061279296875,
        170.0
      ],
      [
        794.0264282226562,
        1069.2847900390625,
        170.0
      ],
      [
        796.0811157226562,
        1016.168212890625,
        170.0
      ],
      [
        1020.0,
        930.0,
        130.0
      ],
      [
        1017.9999389648438,
        930.0,
        80.0
      ],
      [
        1030.0,
        926.0,
        80.0
      ],
      [
        1017.9999389648438,
        926.0,
        80.0
      ],
      [
        1030.0,
        905.9572143554688,
        80.0
      ],
      [
        1017.9999389648438,
        910.5136108398438,
        80.0
      ],
      [
        1010.0,
        959.9999389648438,
        130.0
      ],
      [
        1010.0,
        961.9999389648438,
        80.0
      ],
      [
        1010.0,
        926.0,
        80.0
      ],
      [
        1017.9999389648438,
        926.0,
        80.0
      ],
      [
        1006.0,
        930.0,
        80.0
      ],
      [
        1010.0,
        926.0,
        80.0
      ],
      [
        1006.0,
        926.0,
        80.0
      ],
      [
        1006.0,
        930.0,
        80.0
      ],
      [
        1006.0,
        957.9999389648438,
        80.0
      ],
      [
        1010.0,
        961.9999389648438,
        80.0
      ],
      [
        1006.0,
        1022.143798828125,
        80.0
      ],
      [
        1010.0,
        913.5511474609375,
        80.0
      ],
      [
        1006.0,
        915.0699462890625,
        80.0
      ],
      [
        1010.0,
        913.5511474609375,
        80.0
      ],
      [
        914.0048828125,
        950.0,
        140.0
      ],
      [
        914.0048828125,
        950.0,
        220.0
      ],
      [
        914.0048828125,
        950.0,
        220.0
      ],
      [
        964.2264404296875,
        930.93115234375,
        308.9880065917969
      ],
      [
        914.0048828125,
        950.0,
        140.0
      ],
      [
        963.1941528320312,
        931.3230590820312,
        140.0
      ],
      [
        963.1941528320312,
        931.3230590820312,
        140.0
      ],
      [
        982.33837890625,
        924.0541381835938,
        140.0
      ],
      [
        960.0,
        950.0,
        80.0
      ],
      [
        960.0,
        932.535888671875,
        80.0
      ],
      [
        914.0048217773438,
        950.0,
        74.8894271850586
      ],
      [
        966.6787109375,
        930.0,
        80.0
      ],
      [
        966.6787109375,
        930.0,
        80.0
      ],
      [
        960.0,
        932.535888671875,
        80.0
      ],
      [
        960.0,
        950.0,
        80.0
      ],
      [
        1006.0,
        950.0,
        80.0
      ],
      [
        981.8887939453125,
        924.224853515625,
        120.0
      ],
      [
        980.0,
        924.9420166015625,
        120.0
      ],
      [
        961.8380126953125,
        931.8380126953125,
        120.0
      ],
      [
        980.0,
        924.9420166015625,
        120.0
      ],
      [
        961.8380126953125,
        931.8380126953125,
        118.0
      ],
      [
        961.8380126953125,
        931.8380126953125,
        120.0
      ],
      [
        1000.0,
        950.0,
        118.0
      ],
      [
        960.0,
        970.0,
        80.0
      ],
      [
        1006.0,
        970.0,
        80.0
      ],
      [
        1000.0,
        970.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        780.0,
        1038.243896484375,
        110.0
      ],
      [
        780.0,
        1000.8809204101562,
        110.0
      ],
      [
        780.0,
        1000.8809204101562,
        60.0
      ],
      [
        780.0,
        1038.243896484375,
        60.0
      ],
      [
        780.0,
        1000.8809204101562,
        110.0
      ],
      [
        780.0,
        1038.243896484375,
        110.0
      ],
      [
        780.0,
        1038.243896484375,
        60.0
      ],
      [
        780.0,
        1000.8809204101562,
        60.0
      ],
      [
        765.5892944335938,
        1006.3526000976562,
        60.0
      ],
      [
        760.0,
        750.0,
        220.0
      ],
      [
        774.5853881835938,
        735.4146118164062,
        288.0650634765625
      ],
      [
        760.0,
        750.0,
        140.0
      ],
      [
        774.14208984375,
        735.8577880859375,
        140.0
      ],
      [
        774.14208984375,
        735.8577880859375,
        140.0
      ],
      [
        784.14208984375,
        725.85791015625,
        140.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        1030.0,
        707.730224609375,
        140.0
      ],
      [
        950.0,
        640.0,
        140.0
      ],
      [
        950.0,
        640.0,
        170.0
      ],
      [
        950.0,
        600.0,
        170.0
      ],
      [
        950.0,
        600.0,
        140.0
      ],
      [
        760.0,
        750.0,
        140.0
      ],
      [
        760.0,
        950.0,
        170.0
      ],
      [
        760.0,
        750.0,
        170.0
      ],
      [
        914.0048828125,
        950.0,
        170.0
      ],
      [
        760.0,
        950.0,
        170.0
      ],
      [
        760.0,
        750.0,
        220.0
      ],
      [
        950.0,
        559.9999389648438,
        220.0
      ],
      [
        950.0,
        559.9999389648438,
        250.0
      ],
      [
        870.0000610351562,
        640.0,
        250.0
      ],
      [
        930.0,
        579.9998779296875,
        250.0
      ],
      [
        860.0,
        650.0,
        60.0
      ],
      [
        820.471435546875,
        689.5284423828125,
        60.0
      ],
      [
        1030.0,
        901.9790649414062,
        80.0
      ],
      [
        885.6575927734375,
        707.730224609375,
        120.0
      ],
      [
        901.8654174804688,
        707.730224609375,
        140.0
      ],
      [
        885.6575927734375,
        707.730224609375,
        120.0
      ],
      [
        860.0,
        650.0,
        60.0
      ],
      [
        870.0,
        640.0,
        80.0
      ],
      [
        950.0,
        620.0,
        120.0
      ],
      [
        950.0,
        610.0,
        140.0
      ],
      [
        850.0,
        660.0,
        98.0
      ],
      [
        842.5957641601562,
        680.0,
        98.0
      ],
      [
        836.5947875976562,
        673.4052734375,
        98.0
      ],
      [
        844.216552734375,
        680.0,
        100.0
      ],
      [
        850.0,
        660.0,
        100.0
      ],
      [
        837.443359375,
        672.556640625,
        100.0
      ],
      [
        850.0,
        660.0,
        98.0
      ],
      [
        850.0,
        660.0,
        100.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        884.0368041992188,
        707.730224609375,
        118.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        120.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        830.0000610351562,
        680.0,
        100.0
      ],
      [
        830.0000610351562,
        680.0,
        98.0
      ],
      [
        760.0,
        750.0001220703125,
        118.0
      ],
      [
        760.0,
        750.0001220703125,
        120.0
      ],
      [
        769.9999389648438,
        739.9999389648438,
        60.0
      ],
      [
        819.9999389648438,
        689.9999389648438,
        60.0
      ],
      [
        780.0,
        984.2857666015625,
        60.0
      ],
      [
        769.9999389648438,
        739.9999389648438,
        60.0
      ],
      [
        760.0,
        749.9998779296875,
        60.0
      ],
      [
        760.0,
        984.2857666015625,
        60.0
      ],
      [
        819.9999389648438,
        689.9999389648438,
        60.0
      ],
      [
        780.0,
        930.0,
        73.84615325927734
      ],
      [
        960.0,
        930.0,
        87.69231414794922
      ],
      [
        780.0,
        930.0,
        73.84615325927734
      ],
      [
        780.0,
        970.0,
        76.92308044433594
      ],
      [
        861.3308715820312,
        970.0,
        83.1792984008789
      ],
      [
        780.0,
        970.0,
        76.92308044433594
      ],
      [
        780.0,
        984.2857666015625,
        60.0
      ],
      [
        780.0,
        980.4865112304688,
        77.729736328125
      ],
      [
        770.0,
        740.0,
        120.0
      ],
      [
        777.071044921875,
        732.928955078125,
        120.0
      ],
      [
        777.071044921875,
        732.928955078125,
        120.0
      ],
      [
        791.2132568359375,
        718.7867431640625,
        120.0
      ],
      [
        798.2843627929688,
        711.7157592773438,
        120.0
      ],
      [
        791.2132568359375,
        718.7867431640625,
        120.0
      ],
      [
        760.0,
        750.0001220703125,
        120.0
      ],
      [
        770.0,
        740.0,
        120.0
      ],
      [
        770.0,
        740.0,
        118.0
      ],
      [
        760.0,
        750.0001220703125,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        780.0,
        930.0,
        118.0
      ],
      [
        780.0,
        930.0,
        118.0
      ],
      [
        780.0,
        750.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        824.0,
        950.0,
        118.0
      ],
      [
        780.0,
        973.5714111328125,
        110.0
      ],
      [
        780.0,
        973.5714111328125,
        110.0
      ],
      [
        851.9248657226562,
        973.5714111328125,
        110.0
      ],
      [
        836.0,
        930.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        730.0,
        780.0,
        60.0
      ],
      [
        730.0,
        927.5926513671875,
        60.0
      ],
      [
        755.617919921875,
        984.2857666015625,
        60.0
      ],
      [
        743.1985473632812,
        956.8014526367188,
        80.0
      ],
      [
        735.6064453125,
        940.0,
        80.0
      ],
      [
        760.0,
        979.9999389648438,
        80.0
      ],
      [
        743.1985473632812,
        956.8014526367188,
        80.0
      ],
      [
        753.6812744140625,
        980.0,
        80.0
      ],
      [
        760.0,
        750.0000610351562,
        80.0
      ],
      [
        740.0,
        770.0001220703125,
        80.0
      ],
      [
        740.0,
        770.0001220703125,
        80.0
      ],
      [
        740.0,
        770.0001220703125,
        78.0
      ],
      [
        735.6064453125,
        940.0,
        80.0
      ],
      [
        735.6064453125,
        940.0,
        78.0
      ],
      [
        760.0,
        993.9834594726562,
        80.0
      ],
      [
        694.9381103515625,
        850.0,
        240.0
      ],
      [
        720.0,
        790.0000610351562,
        240.0
      ],
      [
        684.064208984375,
        825.935791015625,
        240.0
      ],
      [
        780.0,
        1042.291015625,
        110.0
      ],
      [
        780.0,
        1042.291015625,
        60.0
      ],
      [
        781.3767700195312,
        1041.290771484375,
        110.0
      ],
      [
        780.0,
        1042.291015625,
        110.0
      ],
      [
        780.0,
        1042.291015625,
        60.0
      ],
      [
        730.0,
        1078.6180419921875,
        60.0
      ],
      [
        760.0,
        1056.82177734375,
        80.0
      ],
      [
        740.0,
        1071.3526611328125,
        80.0
      ],
      [
        740.0,
        1071.3526611328125,
        78.0
      ],
      [
        740.0,
        1071.3526611328125,
        80.0
      ],
      [
        706.0318603515625,
        1096.0318603515625,
        120.0
      ],
      [
        720.0,
        1085.8834228515625,
        120.0
      ],
      [
        706.0318603515625,
        1096.0318603515625,
        160.0
      ],
      [
        720.0,
        1085.8834228515625,
        160.0
      ],
      [
        529.9999389648438,
        980.0,
        160.0
      ],
      [
        529.9999389648438,
        980.0,
        190.0
      ],
      [
        529.9999389648438,
        980.0,
        80.0
      ],
      [
        529.9999389648438,
        980.0,
        120.0
      ],
      [
        510.00006103515625,
        1000.0,
        160.0
      ],
      [
        510.00006103515625,
        1000.0,
        120.0
      ],
      [
        490.0,
        1221.862548828125,
        190.0
      ],
      [
        490.0,
        1020.0000610351562,
        190.0
      ],
      [
        490.0,
        1020.0000610351562,
        290.0
      ],
      [
        490.0,
        1221.862548828125,
        290.0
      ],
      [
        704.0,
        1000.0,
        120.0
      ],
      [
        720.0,
        1000.0,
        120.0
      ],
      [
        762.71875,
        1000.0,
        60.0
      ],
      [
        730.0,
        1000.0,
        60.0
      ],
      [
        740.0,
        1000.0,
        78.0
      ],
      [
        740.0,
        1000.0,
        80.0
      ],
      [
        760.0,
        1000.0,
        80.0
      ],
      [
        740.0,
        1000.0,
        80.0
      ],
      [
        780.0,
        1038.243896484375,
        80.0
      ],
      [
        780.0,
        1042.291015625,
        80.0
      ],
      [
        720.0,
        1000.0,
        160.0
      ],
      [
        514.0000610351562,
        996.0,
        120.0
      ],
      [
        510.00006103515625,
        1000.0,
        120.0
      ],
      [
        529.9999389648438,
        980.0,
        120.0
      ],
      [
        510.00006103515625,
        1000.0,
        120.0
      ],
      [
        753.6813354492188,
        980.0,
        60.0
      ],
      [
        730.0,
        980.0,
        60.0
      ],
      [
        753.6812744140625,
        980.0,
        80.0
      ],
      [
        740.0,
        980.0,
        80.0
      ],
      [
        740.0,
        980.0,
        78.0
      ],
      [
        740.0,
        980.0,
        80.0
      ],
      [
        510.00006103515625,
        1000.0,
        160.0
      ],
      [
        529.9999389648438,
        980.0,
        160.0
      ],
      [
        540.0000610351562,
        970.0,
        60.0
      ],
      [
        530.0,
        980.0,
        80.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        530.0,
        980.0,
        78.0
      ],
      [
        531.0,
        979.0,
        78.0
      ],
      [
        740.0,
        979.0,
        78.0
      ],
      [
        749.1626586914062,
        970.0,
        60.0
      ],
      [
        540.0000610351562,
        970.0,
        60.0
      ],
      [
        580.0,
        930.0,
        60.0
      ],
      [
        590.0,
        920.0,
        80.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        80.0
      ],
      [
        570.0,
        940.0,
        80.0
      ],
      [
        530.0,
        980.0,
        80.0
      ],
      [
        570.0,
        940.0,
        78.0
      ],
      [
        570.0,
        940.0,
        78.0
      ],
      [
        570.0,
        940.0,
        80.0
      ],
      [
        721.0,
        921.0,
        78.0
      ],
      [
        590.0000610351562,
        920.0,
        80.0
      ],
      [
        589.0000610351562,
        921.0,
        78.0
      ],
      [
        580.0,
        930.0,
        60.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        80.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        140.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        140.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        240.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        240.0
      ],
      [
        650.0,
        860.0,
        240.0
      ],
      [
        660.0,
        850.0,
        240.0
      ],
      [
        440.0,
        1070.0,
        120.0
      ],
      [
        440.0,
        1070.0,
        145.0
      ],
      [
        440.0,
        1070.0,
        120.0
      ],
      [
        429.5,
        1080.5,
        120.0
      ],
      [
        420.0,
        1181.0,
        79.0
      ],
      [
        429.5,
        1080.5,
        79.0
      ],
      [
        420.0,
        1090.0,
        79.0
      ],
      [
        429.5,
        1080.5,
        145.0
      ],
      [
        440.0,
        1070.0,
        145.0
      ],
      [
        420.0,
        1181.0,
        145.0
      ],
      [
        420.0,
        1090.0,
        145.0
      ],
      [
        429.5,
        1080.5,
        145.0
      ],
      [
        429.5,
        1080.5,
        145.0
      ],
      [
        429.5,
        1080.5,
        120.0
      ],
      [
        429.5,
        1080.5,
        120.0
      ],
      [
        429.5,
        1080.5,
        145.0
      ],
      [
        420.0,
        400.1343994140625,
        -300.0
      ],
      [
        420.0,
        -1430.524658203125,
        -300.0
      ],
      [
        420.0,
        -2563.9130859375,
        1443.904296875
      ],
      [
        420.0,
        -2421.25,
        1308.39501953125
      ],
      [
        420.0,
        -1918.4615478515625,
        641.8307495117188
      ],
      [
        420.0,
        -2421.25,
        1308.39501953125
      ],
      [
        2400.0,
        -1546.8843994140625,
        433.001953125
      ],
      [
        2356.415771484375,
        -1161.2073974609375,
        252.5999755859375
      ],
      [
        2400.0,
        -1165.082275390625,
        259.4555358886719
      ],
      [
        420.0,
        -1556.2850341796875,
        204.23513793945312
      ],
      [
        420.0,
        -1558.4227294921875,
        206.8179931640625
      ],
      [
        420.0,
        -1918.4615478515625,
        641.8307495117188
      ],
      [
        420.0,
        920.0,
        80.0
      ],
      [
        420.0,
        920.0,
        140.0
      ],
      [
        420.0,
        920.0,
        140.0
      ],
      [
        420.0,
        920.0,
        460.0
      ],
      [
        420.0,
        510.0,
        220.0
      ],
      [
        420.0,
        271.7467041015625,
        220.0
      ],
      [
        420.0,
        369.22314453125,
        60.0
      ],
      [
        420.0,
        430.77685546875,
        60.0
      ],
      [
        420.0,
        570.0,
        60.0
      ],
      [
        420.0,
        520.0,
        60.0
      ],
      [
        856.760986328125,
        304.0712890625,
        100.0
      ],
      [
        856.760986328125,
        314.0712890625,
        100.0
      ],
      [
        866.760986328125,
        304.0712890625,
        100.0
      ],
      [
        856.760986328125,
        304.0712890625,
        100.0
      ],
      [
        800.8497314453125,
        643.9796142578125,
        98.0
      ],
      [
        796.8701171875,
        640.0,
        98.0
      ],
      [
        800.8497314453125,
        643.9796142578125,
        98.0
      ],
      [
        805.0,
        648.1298828125,
        98.0
      ],
      [
        816.8701171875,
        660.0,
        98.0
      ],
      [
        833.43505859375,
        676.5650024414062,
        98.0
      ],
      [
        816.8701171875,
        660.0,
        98.0
      ],
      [
        818.2843017578125,
        660.0,
        100.0
      ],
      [
        660.0,
        501.7156982421875,
        100.0
      ],
      [
        630.0,
        487.2720642089844,
        78.0
      ],
      [
        650.0,
        507.2720642089844,
        78.0
      ],
      [
        630.0,
        485.8578186035156,
        80.0
      ],
      [
        650.0,
        505.85784912109375,
        80.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        824.1422119140625,
        680.0,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        660.0,
        515.8578491210938,
        98.0
      ],
      [
        660.0,
        503.1299133300781,
        98.0
      ],
      [
        630.0,
        553.85791015625,
        80.0
      ],
      [
        630.0,
        542.5441284179688,
        80.0
      ],
      [
        630.0,
        542.5441284179688,
        80.0
      ],
      [
        630.0,
        553.85791015625,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        80.0
      ],
      [
        630.0,
        750.0,
        80.0
      ],
      [
        630.0,
        614.1421508789062,
        80.0
      ],
      [
        630.0,
        542.5441284179688,
        78.0
      ],
      [
        630.0,
        553.85791015625,
        78.0
      ],
      [
        630.0,
        542.5441284179688,
        78.0
      ],
      [
        630.0,
        566.14208984375,
        78.0
      ],
      [
        630.0,
        553.85791015625,
        78.0
      ],
      [
        760.0,
        689.9500122070312,
        78.0
      ],
      [
        770.0,
        689.9500122070312,
        78.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        80.0
      ],
      [
        630.0,
        566.14208984375,
        78.0
      ],
      [
        670.7326049804688,
        555.0899658203125,
        98.0
      ],
      [
        670.7326049804688,
        555.0900268554688,
        100.0
      ],
      [
        784.1422119140625,
        668.2536010742188,
        98.0
      ],
      [
        784.1422119140625,
        668.2536010742188,
        100.0
      ],
      [
        630.0,
        750.0,
        98.0
      ],
      [
        630.0,
        750.0,
        100.0
      ],
      [
        720.0,
        750.0,
        98.0
      ],
      [
        675.4915771484375,
        569.2073364257812,
        98.0
      ],
      [
        668.4205322265625,
        576.2783813476562,
        98.0
      ],
      [
        668.4205322265625,
        576.2783813476562,
        98.0
      ],
      [
        630.0,
        750.0,
        80.0
      ],
      [
        420.0,
        570.0,
        60.0
      ],
      [
        420.0,
        580.0,
        80.0
      ],
      [
        550.0,
        579.0,
        78.0
      ],
      [
        570.0,
        579.0,
        78.0
      ],
      [
        550.0,
        579.0,
        78.0
      ],
      [
        499.80194091796875,
        920.0,
        100.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        100.0
      ],
      [
        420.0,
        580.0,
        80.0
      ],
      [
        420.0,
        580.0,
        100.0
      ],
      [
        420.0,
        540.0,
        80.0
      ],
      [
        420.0,
        540.0,
        78.0
      ],
      [
        420.0,
        560.0,
        78.0
      ],
      [
        420.0,
        560.0,
        80.0
      ],
      [
        630.0,
        540.0,
        80.0
      ],
      [
        630.0,
        560.0,
        80.0
      ],
      [
        420.0,
        540.0,
        80.0
      ],
      [
        420.0,
        560.0,
        80.0
      ],
      [
        630.0,
        540.0,
        78.0
      ],
      [
        630.0,
        560.0,
        78.0
      ],
      [
        420.0,
        560.0,
        78.0
      ],
      [
        420.0,
        540.0,
        78.0
      ],
      [
        420.0,
        344.45166015625,
        80.0
      ],
      [
        420.0,
        455.54833984375,
        80.0
      ],
      [
        420.0,
        455.54833984375,
        78.0
      ],
      [
        420.0,
        344.45166015625,
        78.0
      ],
      [
        523.7213745117188,
        280.5788269042969,
        78.0
      ],
      [
        621.0,
        289.8044738769531,
        78.0
      ],
      [
        456.27862548828125,
        511.0,
        78.0
      ],
      [
        420.0,
        510.0,
        80.0
      ],
      [
        420.0,
        511.0,
        78.0
      ],
      [
        621.0,
        511.0,
        78.0
      ],
      [
        523.7213745117188,
        511.0,
        78.0
      ],
      [
        579.4631958007812,
        400.0,
        78.0
      ],
      [
        562.3772583007812,
        347.4148864746094,
        78.0
      ],
      [
        629.7952880859375,
        511.0,
        78.0
      ],
      [
        562.3772583007812,
        452.5851135253906,
        78.0
      ],
      [
        579.4631958007812,
        400.0,
        78.0
      ],
      [
        562.3772583007812,
        347.4148864746094,
        78.0
      ],
      [
        523.7213745117188,
        319.3297424316406,
        78.0
      ],
      [
        523.7213745117188,
        319.3297424316406,
        78.0
      ],
      [
        523.7213745117188,
        280.5788269042969,
        78.0
      ],
      [
        523.7213745117188,
        480.6702575683594,
        78.0
      ],
      [
        562.3772583007812,
        452.5851135253906,
        78.0
      ],
      [
        523.7213745117188,
        511.0,
        78.0
      ],
      [
        523.7213745117188,
        480.6702575683594,
        78.0
      ],
      [
        523.7213745117188,
        481.1797790527344,
        78.0
      ],
      [
        523.0199584960938,
        481.1797790527344,
        78.0
      ],
      [
        480.0,
        510.0,
        80.0
      ],
      [
        480.0,
        511.0,
        78.0
      ],
      [
        420.0,
        520.0,
        60.0
      ],
      [
        620.0,
        290.714111328125,
        100.0
      ],
      [
        620.0,
        510.0,
        100.0
      ],
      [
        420.0,
        510.0,
        100.0
      ],
      [
        420.0,
        510.0,
        80.0
      ],
      [
        455.27862548828125,
        510.0,
        100.0
      ],
      [
        580.5146484375,
        400.0,
        100.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        100.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        100.0
      ],
      [
        580.5146484375,
        400.0,
        100.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        100.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        100.0
      ],
      [
        524.7213745117188,
        510.0,
        100.0
      ],
      [
        524.7213745117188,
        481.1797790527344,
        100.0
      ],
      [
        498.8174743652344,
        500.0,
        100.0
      ],
      [
        498.8174743652344,
        500.0,
        95.5
      ],
      [
        498.8174743652344,
        500.0,
        95.5
      ],
      [
        505.6994934082031,
        495.0,
        95.5
      ],
      [
        455.2785949707031,
        500.0,
        95.5
      ],
      [
        620.0,
        290.714111328125,
        190.0
      ],
      [
        620.0,
        290.714111328125,
        140.0
      ],
      [
        524.7213745117188,
        281.67816162109375,
        140.0
      ],
      [
        524.7213745117188,
        281.67816162109375,
        190.0
      ],
      [
        524.7213745117188,
        510.0,
        190.0
      ],
      [
        620.0,
        510.0,
        190.0
      ],
      [
        420.0,
        510.0,
        190.0
      ],
      [
        420.0,
        510.0,
        140.0
      ],
      [
        455.27862548828125,
        510.0,
        140.0
      ],
      [
        455.27862548828125,
        510.0,
        190.0
      ],
      [
        455.2785949707031,
        500.0,
        190.0
      ],
      [
        524.7213745117188,
        500.0,
        190.0
      ],
      [
        524.7213745117188,
        500.0,
        140.0
      ],
      [
        524.7213745117188,
        500.0,
        190.0
      ],
      [
        455.2785949707031,
        500.0,
        190.0
      ],
      [
        455.2785949707031,
        500.0,
        140.0
      ],
      [
        580.5146484375,
        400.0,
        190.0
      ],
      [
        580.5146484375,
        400.0,
        140.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        140.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        190.0
      ],
      [
        660.0,
        500.0,
        140.0
      ],
      [
        660.0,
        500.0,
        150.0
      ],
      [
        660.0,
        500.0,
        190.0
      ],
      [
        660.0,
        500.0,
        150.0
      ],
      [
        856.760986328125,
        313.1678466796875,
        140.0
      ],
      [
        856.760986328125,
        314.0712890625,
        140.0
      ],
      [
        856.760986328125,
        313.1678466796875,
        150.0
      ],
      [
        559.7213745117188,
        500.0,
        145.0
      ],
      [
        600.0,
        500.0,
        145.0
      ],
      [
        600.0,
        500.0,
        145.0
      ],
      [
        600.0,
        485.0,
        140.0
      ],
      [
        600.0,
        500.0,
        140.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        190.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        140.0
      ],
      [
        580.5146484375,
        400.0,
        140.0
      ],
      [
        580.5146484375,
        400.0,
        190.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        190.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        140.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        140.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        190.0
      ],
      [
        524.7213745117188,
        281.6781921386719,
        190.0
      ],
      [
        524.7213745117188,
        281.67816162109375,
        140.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        140.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        190.0
      ],
      [
        480.0,
        280.0,
        140.0
      ],
      [
        500.0,
        280.0,
        140.0
      ],
      [
        524.7213745117188,
        481.1797790527344,
        190.0
      ],
      [
        524.7213745117188,
        481.1797790527344,
        140.0
      ],
      [
        524.7213745117188,
        500.0,
        140.0
      ],
      [
        524.7213745117188,
        500.0,
        190.0
      ],
      [
        524.7213745117188,
        510.0,
        140.0
      ],
      [
        524.7213745117188,
        510.0,
        190.0
      ],
      [
        660.0,
        510.0,
        140.0
      ],
      [
        660.0,
        510.0,
        150.0
      ],
      [
        660.0,
        510.0,
        190.0
      ],
      [
        660.0,
        510.0,
        150.0
      ],
      [
        600.0,
        508.0,
        140.0
      ],
      [
        866.760986328125,
        304.0712890625,
        140.0
      ],
      [
        856.760986328125,
        304.0712890625,
        140.0
      ],
      [
        856.760986328125,
        304.0712890625,
        140.0
      ],
      [
        550.0,
        750.0,
        190.0
      ],
      [
        720.0,
        750.0,
        190.0
      ],
      [
        549.9669799804688,
        869.8349609375,
        190.0
      ],
      [
        499.80194091796875,
        920.0,
        190.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        190.0
      ],
      [
        549.9669799804688,
        869.8349609375,
        190.0
      ],
      [
        550.0,
        580.0,
        190.0
      ],
      [
        430.0,
        580.0,
        190.0
      ],
      [
        420.0,
        580.0,
        140.0
      ],
      [
        420.0,
        580.0,
        160.0
      ],
      [
        840.0,
        580.0,
        190.0
      ],
      [
        840.0,
        580.0,
        140.0
      ],
      [
        430.0,
        650.0,
        190.0
      ],
      [
        430.0,
        580.0,
        190.0
      ],
      [
        760.0,
        750.0,
        190.0
      ],
      [
        760.0,
        701.7157592773438,
        190.0
      ],
      [
        420.0,
        580.0,
        160.0
      ],
      [
        420.0,
        650.0,
        160.0
      ],
      [
        420.0,
        650.0,
        160.0
      ],
      [
        420.0,
        650.0,
        190.0
      ],
      [
        430.0,
        650.0,
        190.0
      ],
      [
        519.8468017578125,
        460.0,
        118.0
      ],
      [
        553.8728637695312,
        460.0,
        118.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        118.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        118.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        118.0
      ],
      [
        524.7213745117188,
        281.67816162109375,
        118.0
      ],
      [
        553.8728637695312,
        460.0,
        120.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        118.0
      ],
      [
        553.8728637695312,
        460.0,
        118.0
      ],
      [
        553.8728637695312,
        460.0,
        100.0
      ],
      [
        420.0,
        580.0,
        140.0
      ],
      [
        524.7213745117188,
        500.0,
        120.0
      ],
      [
        524.7213745117188,
        500.0,
        130.0
      ],
      [
        524.7213745117188,
        500.0,
        120.0
      ],
      [
        524.7213745117188,
        500.0,
        100.0
      ],
      [
        524.7213745117188,
        500.0,
        130.0
      ],
      [
        524.7213745117188,
        500.0,
        140.0
      ],
      [
        600.0,
        500.0,
        140.0
      ],
      [
        600.0,
        500.0,
        130.0
      ],
      [
        550.0,
        750.0,
        220.0
      ],
      [
        720.0,
        750.0,
        220.0
      ],
      [
        549.9669799804688,
        869.8349609375,
        220.0
      ],
      [
        499.80194091796875,
        920.0,
        220.0
      ],
      [
        595.0659790039062,
        914.9339599609375,
        220.0
      ],
      [
        549.9669799804688,
        869.8349609375,
        220.0
      ],
      [
        840.0,
        640.0,
        220.0
      ],
      [
        550.0,
        580.0,
        220.0
      ],
      [
        430.0,
        580.0,
        220.0
      ],
      [
        430.0,
        650.0,
        220.0
      ],
      [
        430.0,
        580.0,
        220.0
      ],
      [
        420.0,
        650.0,
        220.0
      ],
      [
        430.0,
        650.0,
        220.0
      ],
      [
        420.0,
        510.0,
        220.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        215.0
      ],
      [
        580.5146484375,
        400.0,
        215.0
      ],
      [
        580.5146484375,
        400.0,
        215.0
      ],
      [
        563.2279052734375,
        453.2031555175781,
        215.0
      ],
      [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      [
        563.2279052734375,
        346.7968444824219,
        215.0
      ],
      [
        524.7213745117188,
        500.0,
        215.0
      ],
      [
        524.7213745117188,
        500.0,
        190.0
      ],
      [
        609.9009399414062,
        809.9009399414062,
        240.0
      ],
      [
        420.0,
        650.0,
        240.0
      ],
      [
        420.0,
        749.9900512695312,
        240.0
      ],
      [
        609.9009399414062,
        809.9009399414062,
        240.0
      ],
      [
        669.802001953125,
        750.0,
        240.0
      ],
      [
        669.8019409179688,
        750.0,
        240.0
      ],
      [
        669.802001953125,
        750.0,
        220.0
      ],
      [
        420.0,
        650.0,
        240.0
      ],
      [
        840.0,
        500.0,
        240.0
      ],
      [
        840.0,
        579.802001953125,
        220.0
      ],
      [
        840.0,
        579.802001953125,
        240.0
      ],
      [
        420.0,
        749.9900512695312,
        260.0
      ],
      [
        420.0,
        749.9900512695312,
        360.0
      ],
      [
        499.9962463378906,
        749.9961547851562,
        240.0
      ],
      [
        420.0,
        749.9900512695312,
        240.0
      ],
      [
        420.0,
        749.9900512695312,
        260.0
      ],
      [
        499.9962463378906,
        749.9961547851562,
        260.0
      ],
      [
        420.0,
        758.5347290039062,
        360.0
      ],
      [
        420.0,
        758.5347290039062,
        460.0
      ],
      [
        919.8019409179688,
        500.0,
        250.0
      ],
      [
        840.0,
        579.802001953125,
        250.0
      ],
      [
        840.0,
        579.802001953125,
        250.0
      ],
      [
        499.9962463378906,
        749.9961547851562,
        250.0
      ],
      [
        550.0,
        750.0,
        250.0
      ],
      [
        840.0,
        640.0,
        240.0
      ],
      [
        840.0,
        579.802001953125,
        240.0
      ],
      [
        950.0,
        559.9999389648438,
        240.0
      ],
      [
        950.0,
        500.0,
        240.0
      ],
      [
        764.2857055664062,
        745.7142944335938,
        240.0
      ],
      [
        764.2857055664062,
        711.61767578125,
        240.0
      ],
      [
        766.4285888671875,
        743.5714111328125,
        250.0
      ],
      [
        766.4285888671875,
        716.5686645507812,
        250.0
      ],
      [
        420.0,
        930.0,
        60.0
      ],
      [
        420.0,
        920.0,
        80.0
      ],
      [
        420.0,
        980.0,
        100.0
      ],
      [
        420.0,
        980.0,
        80.0
      ],
      [
        420.0,
        980.0,
        190.0
      ],
      [
        420.0,
        980.0,
        120.0
      ],
      [
        420.0,
        980.0,
        190.0
      ],
      [
        420.0,
        980.0,
        340.0
      ],
      [
        420.0,
        985.0,
        79.0
      ],
      [
        420.0,
        985.0,
        79.0
      ],
      [
        420.0,
        985.0,
        76.0
      ],
      [
        429.5,
        985.0,
        79.0
      ],
      [
        420.0,
        985.0,
        145.0
      ],
      [
        490.0,
        1000.0,
        160.0
      ],
      [
        490.0,
        980.0,
        160.0
      ],
      [
        440.0,
        1000.0,
        145.0
      ],
      [
        490.0,
        1000.0,
        160.0
      ],
      [
        490.0,
        1000.0,
        145.0
      ],
      [
        440.0,
        997.0,
        145.0
      ],
      [
        440.0,
        983.0,
        145.0
      ],
      [
        440.0,
        983.0,
        145.0
      ],
      [
        440.0,
        997.0,
        145.0
      ],
      [
        440.0,
        1000.0,
        145.0
      ],
      [
        440.0,
        997.0,
        145.0
      ],
      [
        440.0,
        980.0,
        145.0
      ],
      [
        440.0,
        983.0,
        145.0
      ],
      [
        420.0,
        985.0,
        120.0
      ],
      [
        420.0,
        1007.0,
        120.0
      ],
      [
        490.0,
        996.0,
        120.0
      ],
      [
        490.0,
        1000.0,
        120.0
      ],
      [
        490.0,
        980.0,
        120.0
      ],
      [
        490.0,
        1000.0,
        120.0
      ],
      [
        420.0,
        985.0,
        120.0
      ],
      [
        490.0,
        1000.0,
        120.0
      ],
      [
        420.0,
        985.0,
        145.0
      ],
      [
        420.0,
        985.0,
        120.0
      ],
      [
        420.0,
        940.0,
        78.0
      ],
      [
        420.0,
        940.0,
        80.0
      ],
      [
        420.0,
        970.0,
        60.0
      ],
      [
        570.0,
        940.0,
        60.0
      ],
      [
        420.0,
        940.0,
        60.0
      ],
      [
        420.0,
        940.0,
        80.0
      ],
      [
        420.0,
        980.0,
        80.0
      ],
      [
        420.0,
        940.0,
        78.0
      ],
      [
        420.0,
        980.0,
        78.0
      ],
      [
        420.0,
        979.0,
        78.0
      ],
      [
        420.0,
        980.0,
        80.0
      ],
      [
        531.0,
        979.0,
        78.0
      ],
      [
        420.0,
        970.0,
        60.0
      ],
      [
        420.0,
        980.0,
        120.0
      ],
      [
        420.0,
        960.0,
        105.0
      ],
      [
        420.0,
        980.0,
        100.0
      ],
      [
        420.0,
        960.0,
        100.0
      ],
      [
        420.0,
        960.0,
        100.0
      ],
      [
        420.0,
        960.0,
        105.0
      ],
      [
        420.0,
        960.0,
        100.0
      ],
      [
        420.0,
        960.0,
        105.0
      ],
      [
        420.0,
        930.0,
        60.0
      ],
      [
        370.0,
        1140.0,
        145.0
      ],
      [
        420.0,
        1090.0,
        145.0
      ],
      [
        420.0,
        1090.0,
        79.0
      ],
      [
        370.0,
        1140.0,
        79.0
      ],
      [
        370.0,
        1181.0,
        79.0
      ],
      [
        370.0,
        1140.0,
        76.0
      ],
      [
        370.0,
        1140.0,
        79.0
      ],
      [
        370.0,
        1140.0,
        120.0
      ],
      [
        370.0,
        1140.0,
        145.0
      ],
      [
        370.0,
        1140.0,
        120.0
      ],
      [
        -1062.5450439453125,
        -1643.6373291015625,
        75.39681243896484
      ],
      [
        -1048.07763671875,
        -1533.128173828125,
        0.0
      ],
      [
        -160.0,
        970.0,
        60.0
      ],
      [
        -160.0,
        970.0,
        144.0
      ],
      [
        -160.0,
        970.0,
        144.0
      ],
      [
        -160.0,
        970.0,
        230.0
      ],
      [
        -100.0,
        970.0,
        155.0
      ],
      [
        -100.0,
        970.0,
        230.0
      ],
      [
        310.0,
        970.0,
        112.5
      ],
      [
        260.0,
        970.0,
        112.5
      ],
      [
        -160.0,
        980.0,
        60.0
      ],
      [
        -160.0,
        980.0,
        144.0
      ],
      [
        -160.0,
        980.0,
        144.0
      ],
      [
        -160.0,
        980.0,
        230.0
      ],
      [
        -100.0,
        980.0,
        155.0
      ],
      [
        -100.0,
        980.0,
        230.0
      ],
      [
        300.0,
        980.0,
        120.0
      ],
      [
        300.0,
        970.0,
        112.5
      ],
      [
        370.0,
        1140.0,
        100.00006103515625
      ],
      [
        370.0,
        985.0,
        100.00006103515625
      ],
      [
        370.0,
        790.0107421875,
        80.0
      ],
      [
        370.0,
        709.9679565429688,
        80.0
      ],
      [
        370.0,
        540.0,
        80.0
      ],
      [
        359.9999694824219,
        540.0,
        80.0
      ],
      [
        359.9999694824219,
        560.0,
        80.0
      ],
      [
        370.0,
        560.0,
        80.0
      ],
      [
        370.0,
        940.0,
        80.0
      ],
      [
        359.9999694824219,
        980.0,
        80.0
      ],
      [
        370.0,
        980.0,
        80.0
      ],
      [
        370.0,
        560.0,
        78.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        540.0,
        78.0
      ],
      [
        370.0,
        540.0,
        78.0
      ],
      [
        370.0,
        940.0,
        78.0
      ],
      [
        370.0,
        980.0,
        78.0
      ],
      [
        360.0,
        980.0,
        78.0
      ],
      [
        360.0,
        579.0,
        78.0
      ],
      [
        370.0,
        580.0,
        80.0
      ],
      [
        370.0,
        579.0,
        78.0
      ],
      [
        359.9999694824219,
        979.0,
        78.0
      ],
      [
        359.9999694824219,
        980.0,
        80.0
      ],
      [
        370.0,
        980.0,
        80.0
      ],
      [
        370.0,
        979.0,
        78.0
      ],
      [
        370.0,
        921.0,
        78.0
      ],
      [
        370.0,
        920.0,
        80.0
      ],
      [
        360.0,
        921.0,
        78.0
      ],
      [
        370.0,
        940.0,
        78.0
      ],
      [
        370.0,
        940.0,
        80.0
      ],
      [
        359.9999694824219,
        540.0,
        80.0
      ],
      [
        370.0,
        540.0,
        80.0
      ],
      [
        370.0,
        540.0,
        78.0
      ],
      [
        360.0,
        540.0,
        78.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        370.0,
        560.0,
        78.0
      ],
      [
        370.0,
        560.0,
        80.0
      ],
      [
        359.9999694824219,
        560.0,
        80.0
      ],
      [
        370.0,
        511.0,
        78.0
      ],
      [
        370.0,
        510.0,
        80.0
      ],
      [
        360.0,
        511.0,
        78.0
      ],
      [
        370.0,
        570.0,
        60.0
      ],
      [
        360.0,
        570.0,
        60.0
      ],
      [
        370.0,
        970.0,
        60.0
      ],
      [
        360.0,
        970.0,
        60.0
      ],
      [
        360.0,
        930.0,
        60.0
      ],
      [
        370.0,
        930.0,
        60.0
      ],
      [
        370.0,
        520.0,
        60.0
      ],
      [
        370.0,
        709.9679565429688,
        80.0
      ],
      [
        370.0,
        709.9679565429688,
        100.0000228881836
      ],
      [
        370.0,
        510.0,
        80.0
      ],
      [
        370.0,
        510.0,
        100.00001525878906
      ],
      [
        370.0,
        580.0,
        80.0
      ],
      [
        370.0,
        580.0,
        100.00001525878906
      ],
      [
        370.0,
        790.0107421875,
        80.0
      ],
      [
        370.0,
        790.0107421875,
        100.00001525878906
      ],
      [
        370.0,
        920.0,
        80.0
      ],
      [
        370.0,
        920.0,
        100.0000228881836
      ],
      [
        369.9999694824219,
        980.0,
        100.0
      ],
      [
        370.0,
        980.0,
        80.0
      ],
      [
        359.9999694824219,
        980.0,
        80.0
      ],
      [
        370.0,
        579.0,
        78.0
      ],
      [
        370.0,
        579.5,
        79.0
      ],
      [
        420.0,
        579.5,
        79.0
      ],
      [
        420.0,
        579.0,
        78.0
      ],
      [
        370.0,
        979.0,
        78.0
      ],
      [
        370.0,
        979.5,
        79.0
      ],
      [
        420.0,
        979.5,
        79.0
      ],
      [
        420.0,
        979.0,
        78.0
      ],
      [
        370.0,
        985.0,
        79.0
      ],
      [
        370.0,
        985.0,
        78.0
      ],
      [
        420.0,
        985.0,
        78.0
      ],
      [
        420.0,
        985.0,
        79.0
      ],
      [
        420.0,
        921.0,
        78.0
      ],
      [
        420.0,
        920.5,
        79.0
      ],
      [
        370.0,
        920.5,
        79.0
      ],
      [
        370.0,
        921.0,
        78.0
      ],
      [
        370.0,
        940.0,
        79.0
      ],
      [
        420.0,
        940.0,
        79.0
      ],
      [
        420.0,
        540.0,
        79.0
      ],
      [
        370.0,
        540.0,
        79.0
      ],
      [
        420.0,
        560.0,
        79.0
      ],
      [
        370.0,
        560.0,
        79.0
      ],
      [
        420.0,
        511.0,
        78.0
      ],
      [
        420.0,
        510.5,
        79.0
      ],
      [
        370.0,
        510.5,
        79.0
      ],
      [
        370.0,
        511.0,
        78.0
      ],
      [
        392.4999694824219,
        985.0,
        145.0
      ],
      [
        392.4999694824219,
        1117.5,
        145.0
      ],
      [
        399.9999694824219,
        580.0,
        160.0
      ],
      [
        399.9999694824219,
        650.0,
        160.0
      ],
      [
        392.4999694824219,
        580.0,
        145.0
      ],
      [
        399.9999694824219,
        580.0,
        160.0
      ],
      [
        420.0,
        580.0,
        145.0
      ],
      [
        420.0,
        920.0,
        145.0
      ],
      [
        420.0,
        920.0,
        160.0
      ],
      [
        399.9999694824219,
        920.0,
        160.0
      ],
      [
        392.4999694824219,
        920.0,
        145.0
      ],
      [
        410.0213928222656,
        749.9893188476562,
        145.0
      ],
      [
        410.0213928222656,
        749.9893188476562,
        160.0
      ],
      [
        399.9999694824219,
        739.9678955078125,
        160.0
      ],
      [
        392.4999694824219,
        732.4678955078125,
        145.0
      ],
      [
        392.4999694824219,
        767.5107421875,
        145.0
      ],
      [
        399.9999694824219,
        760.0107421875,
        160.0
      ],
      [
        410.0213928222656,
        749.9893188476562,
        160.0
      ],
      [
        410.0213928222656,
        749.9893188476562,
        145.0
      ],
      [
        420.0,
        980.0,
        160.0
      ],
      [
        420.0,
        980.0,
        145.0
      ],
      [
        392.4999694824219,
        980.0,
        145.0
      ],
      [
        399.9999694824219,
        980.0,
        160.0
      ],
      [
        420.0,
        510.0,
        145.0
      ],
      [
        420.0,
        510.0,
        160.0
      ],
      [
        399.9999694824219,
        510.0,
        160.0
      ],
      [
        392.4999694824219,
        510.0,
        145.0
      ],
      [
        420.0,
        920.0,
        200.00009155273438
      ],
      [
        399.9999694824219,
        650.0,
        160.0
      ],
      [
        420.0,
        650.0,
        200.00006103515625
      ],
      [
        410.0213928222656,
        749.9893188476562,
        180.0428466796875
      ],
      [
        410.0213928222656,
        749.9893188476562,
        180.0428466796875
      ],
      [
        420.0,
        510.0,
        200.00006103515625
      ],
      [
        414.9999694824219,
        980.0,
        190.0
      ],
      [
        414.9999694824219,
        980.0,
        190.0
      ],
      [
        420.0,
        980.0,
        200.0000762939453
      ],
      [
        370.0,
        985.0,
        80.0
      ],
      [
        420.0,
        985.0,
        80.0
      ],
      [
        389.9999694824219,
        770.0107421875,
        140.0
      ],
      [
        389.9999694824219,
        770.0107421875,
        140.0
      ],
      [
        389.9999694824219,
        920.0,
        140.0
      ],
      [
        389.9999694824219,
        920.0,
        140.0
      ],
      [
        392.4999694824219,
        985.0,
        145.0
      ],
      [
        379.9999694824219,
        985.0,
        120.0
      ],
      [
        379.9999694824219,
        985.0,
        120.0
      ],
      [
        370.0,
        985.0,
        100.00006103515625
      ],
      [
        369.9999694824219,
        980.0,
        100.0
      ],
      [
        369.9999694824219,
        960.0,
        100.0
      ],
      [
        379.9999694824219,
        980.0,
        120.0
      ],
      [
        372.4999694824219,
        960.0,
        105.0
      ],
      [
        369.9999694824219,
        960.0,
        100.0
      ],
      [
        372.4999694824219,
        960.0,
        105.0
      ],
      [
        369.9999694824219,
        960.0,
        100.0
      ],
      [
        372.4999694824219,
        960.0,
        105.0
      ],
      [
        379.9999694824219,
        980.0,
        120.0
      ],
      [
        379.9999694824219,
        985.0,
        120.0
      ],
      [
        379.9999694824219,
        1007.0,
        120.0
      ],
      [
        389.9999694824219,
        729.9678955078125,
        140.0
      ],
      [
        389.9999694824219,
        729.9678955078125,
        140.0
      ],
      [
        389.9999694824219,
        580.0,
        140.0
      ],
      [
        389.9999694824219,
        580.0,
        140.0
      ],
      [
        359.0,
        730.0,
        78.0
      ],
      [
        359.0,
        731.0,
        78.0
      ],
      [
        358.9999694824219,
        398.9999694824219,
        78.0
      ],
      [
        359.0,
        400.0,
        78.0
      ],
      [
        358.9999694824219,
        280.0,
        78.0
      ],
      [
        359.0,
        399.0,
        78.0
      ],
      [
        358.9999694824219,
        560.0,
        78.0
      ],
      [
        358.9999694824219,
        540.0,
        78.0
      ],
      [
        359.0,
        941.0,
        78.0
      ],
      [
        358.9999694824219,
        731.0,
        78.0
      ],
      [
        358.9999694824219,
        980.0,
        78.0
      ],
      [
        358.9999694824219,
        941.0,
        78.0
      ],
      [
        359.0,
        579.0,
        78.0
      ],
      [
        360.0,
        579.0,
        78.0
      ],
      [
        360.0,
        921.0,
        78.0
      ],
      [
        359.0,
        921.0,
        78.0
      ],
      [
        359.0,
        730.0,
        78.0
      ],
      [
        358.9999694824219,
        979.0,
        78.0
      ],
      [
        359.9999694824219,
        979.0,
        78.0
      ],
      [
        358.9999694824219,
        540.0,
        78.0
      ],
      [
        358.9999694824219,
        560.0,
        78.0
      ],
      [
        360.0,
        280.0,
        78.0
      ],
      [
        360.0,
        280.0,
        80.00001525878906
      ],
      [
        359.0,
        280.0,
        78.0
      ],
      [
        359.0,
        400.0,
        78.0
      ],
      [
        349.9999694824219,
        970.0,
        60.0
      ],
      [
        350.0,
        280.0,
        60.0
      ],
      [
        356.4999694824219,
        434.0,
        73.0
      ],
      [
        356.4999694824219,
        422.0,
        73.0
      ],
      [
        357.4999694824219,
        422.0,
        75.0
      ],
      [
        357.4999694824219,
        434.0,
        75.0
      ],
      [
        356.4999694824219,
        422.0,
        73.0
      ],
      [
        357.4999694824219,
        422.0,
        75.0
      ],
      [
        357.4999694824219,
        434.0,
        75.0
      ],
      [
        356.4999694824219,
        434.0,
        73.0
      ],
      [
        420.0,
        740.0106201171875,
        240.0
      ],
      [
        410.0213928222656,
        749.9893188476562,
        220.0
      ],
      [
        360.0,
        699.9679565429688,
        220.0
      ],
      [
        360.0,
        650.0,
        220.0
      ],
      [
        420.0,
        650.0,
        220.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        340.0,
        560.0,
        78.0
      ],
      [
        340.0,
        560.0,
        80.0
      ],
      [
        340.0,
        400.0,
        78.0
      ],
      [
        340.0,
        400.0,
        80.0
      ],
      [
        359.0,
        280.0,
        78.0
      ],
      [
        340.0,
        280.0,
        80.00000762939453
      ],
      [
        340.0,
        280.0,
        78.0
      ],
      [
        340.0,
        540.0,
        80.0
      ],
      [
        340.0,
        540.0,
        78.0
      ],
      [
        340.0,
        980.0,
        80.0
      ],
      [
        358.9999694824219,
        979.0,
        78.0
      ],
      [
        340.0,
        979.0,
        78.0
      ],
      [
        340.0,
        730.0,
        78.0
      ],
      [
        340.0,
        730.0,
        80.0
      ],
      [
        330.0,
        477.0,
        78.0
      ],
      [
        330.0,
        750.0,
        78.0
      ],
      [
        330.0,
        750.0,
        80.0
      ],
      [
        330.0,
        400.0,
        78.0
      ],
      [
        330.0,
        400.0,
        80.0
      ],
      [
        330.0,
        380.0,
        80.0
      ],
      [
        330.0,
        380.0,
        78.0
      ],
      [
        330.0,
        280.0,
        80.00000762939453
      ],
      [
        310.0,
        280.0,
        80.0
      ],
      [
        310.0,
        280.0,
        78.0
      ],
      [
        330.0,
        280.0,
        78.0
      ],
      [
        320.0,
        477.0,
        78.0
      ],
      [
        330.0,
        477.0,
        78.0
      ],
      [
        320.0,
        477.0,
        78.0
      ],
      [
        310.0,
        979.0,
        78.0
      ],
      [
        330.0,
        980.0,
        80.0
      ],
      [
        330.0,
        979.0,
        78.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        310.0,
        956.0,
        78.0
      ],
      [
        330.0,
        960.0,
        78.0
      ],
      [
        330.0,
        960.0,
        80.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        310.0,
        931.9000244140625,
        63.950008392333984
      ],
      [
        320.0,
        931.9000244140625,
        63.950008392333984
      ],
      [
        320.0,
        458.5,
        63.666656494140625
      ],
      [
        330.0,
        458.5,
        63.666656494140625
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        420.0,
        -1244.851318359375,
        -300.0
      ],
      "bbox_max": [
        7846.55615234375,
        2400.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        420.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        2091.7158203125,
        2400.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1550.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        2091.7158203125,
        1931.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1550.0,
        1654.800048828125,
        500.0
      ],
      "bbox_max": [
        1795.0,
        1931.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1795.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1060.0
      ],
      "bbox_max": [
        1787.0577392578125,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1060.0
      ],
      "bbox_max": [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1565.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1598.0,
        1030.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1565.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1572.0,
        1030.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        420.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1530.0,
        2400.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1030.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1530.0,
        2400.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1030.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1492.0,
        2400.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2400.0,
      "bbox_min": [
        1370.0,
        2400.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        2400.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1030.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1455.0,
        2120.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1405.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1405.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1030.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1405.0,
        2120.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        2120.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1030.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        2120.0,
        800.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1042.949951171875,
        1050.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        2120.0,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1050.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1090.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1050.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1042.949951171875,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1074.050048828125,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1030.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1050.0,
        800.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1135.85791015625,
        960.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1050.0,
        800.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1135.85791015625,
        960.0,
        750.0
      ],
      "bbox_max": [
        1157.0,
        981.1421508789062,
        800.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        796.2144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        960.0,
        580.0
      ],
      "bbox_max": [
        1044.56787109375,
        1093.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.56787109375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.5675048828125,
        977.5806884765625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1030.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1030.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        760.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        944.6153564453125,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        944.6153564453125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1380.0,
        944.6153564453125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1330.0,
        944.6153564453125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1030.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        960.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        939.52001953125,
        118.0
      ],
      "bbox_max": [
        1235.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        939.52001953125,
        118.0
      ],
      "bbox_max": [
        1215.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1037.0,
        960.0,
        630.0003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1030.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        960.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1168.0,
        926.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        939.5999755859375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        929.0399780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        939.5999755859375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1030.0,
        926.0,
        80.0
      ],
      "bbox_max": [
        1171.9998779296875,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        960.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1037.0,
        960.0,
        665.71533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1037.0,
        960.0,
        665.71533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1030.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        960.0,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1160.0,
        960.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1157.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        960.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1030.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        929.199951171875,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        720.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        929.199951171875,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1140.0,
        720.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        929.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1140.0,
        720.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1140.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1140.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        720.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        720.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        920.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        929.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        929.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1030.0,
        720.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8201950788497925,
        -0.3988734185695648,
        0.41009753942489624
      ],
      "plane_d": 1128.7607421875,
      "bbox_min": [
        1030.0,
        825.0,
        170.0
      ],
      "bbox_max": [
        1120.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1030.0,
        825.0,
        170.0
      ],
      "bbox_max": [
        1060.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1030.0,
        720.0,
        120.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1060.0,
        720.0,
        170.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        720.0,
        195.0
      ],
      "bbox_max": [
        1077.730224609375,
        785.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        720.0,
        195.0
      ],
      "bbox_max": [
        1077.730224609375,
        737.730224609375,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 179.99998474121094,
      "bbox_min": [
        1060.0,
        720.0,
        170.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        195.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        720.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        720.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        738.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 318.9051513671875,
      "bbox_min": [
        1171.0,
        720.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        738.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 189.99998474121094,
      "bbox_min": [
        1171.0,
        720.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        738.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        1030.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1480.0,
        720.0,
        300.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        1030.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1360.0,
        720.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        60.0
      ],
      "bbox_max": [
        1360.0,
        720.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1265.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1265.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6193914413452148,
        0.7850823402404785,
        0.0
      ],
      "plane_d": 347.7705078125,
      "bbox_min": [
        1210.0,
        502.3577880859375,
        79.99999237060547
      ],
      "bbox_max": [
        1360.0,
        720.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1290.0,
        502.3577880859375,
        120.0
      ],
      "bbox_max": [
        1290.0,
        574.7734375,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1265.0,
      "bbox_min": [
        1210.0,
        599.730224609375,
        79.99999237060547
      ],
      "bbox_max": [
        1360.0,
        720.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1360.0,
        630.0,
        160.0
      ],
      "bbox_max": [
        1360.0,
        670.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1210.0,
        599.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        720.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        599.730224609375,
        120.0
      ],
      "bbox_max": [
        1235.0,
        720.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1210.0,
        687.730224609375,
        120.0
      ],
      "bbox_max": [
        1215.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        1030.0,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1210.0,
        720.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        1114.72705078125,
        395.27288818359375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        426.63616943359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        1030.0,
        640.0,
        60.0
      ],
      "bbox_max": [
        1210.0,
        720.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 707.730224609375,
      "bbox_min": [
        1030.0,
        640.0,
        80.98199462890625
      ],
      "bbox_max": [
        1210.0,
        720.0,
        200.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1190.0,
        720.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1030.0,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1172.269775390625,
        720.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1077.730224609375,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1090.0,
        720.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 318.9051513671875,
      "bbox_min": [
        1160.0,
        709.0,
        190.0
      ],
      "bbox_max": [
        1171.0,
        720.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 179.99998474121094,
      "bbox_min": [
        1030.0,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1172.269775390625,
        720.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1077.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1090.0,
        720.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1030.0,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1060.0,
        720.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1210.0,
        707.730224609375,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1180.0,
        707.730224609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 687.730224609375,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        1040.0,
        687.730224609375,
        118.0
      ],
      "bbox_max": [
        1040.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1030.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1030.0,
        660.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1030.0,
        640.0,
        115.0
      ],
      "bbox_max": [
        1036.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        420.0,
        559.9999389648438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1346.4150390625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        684.064208984375,
        559.9999389648438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1212.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        765.5892944335938,
        905.9572143554688,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1212.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        783.0528564453125,
        905.9572143554688,
        69.03675842285156
      ],
      "bbox_max": [
        1030.0,
        1212.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        1030.0,
        1212.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        1020.0,
        1212.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        1020.0,
        1150.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        861.3308715820312,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        861.3308715820312,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        868.669189453125,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        861.3308715820312,
        968.6068725585938,
        69.03675842285156
      ],
      "bbox_max": [
        868.669189453125,
        970.0,
        69.85212707519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        861.3308715820312,
        970.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        861.3308715820312,
        970.0,
        80.0
      ],
      "bbox_max": [
        868.669189453125,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 885.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        110.0
      ],
      "bbox_max": [
        1020.0,
        1150.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        885.0,
        976.2007446289062,
        110.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1012.2717895507812,
        110.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        1023.66259765625,
        118.0
      ],
      "bbox_max": [
        1020.0,
        1120.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        1023.66259765625,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        1023.66259765625,
        110.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        885.0,
        976.2007446289062,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1113.79931640625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        110.0
      ],
      "bbox_max": [
        885.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        783.0528564453125,
        982.4061279296875,
        110.0
      ],
      "bbox_max": [
        885.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        794.0264282226562,
        982.4061279296875,
        110.0
      ],
      "bbox_max": [
        885.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        804.9999389648438,
        982.4061279296875,
        170.0
      ],
      "bbox_max": [
        885.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        794.0264282226562,
        1045.0,
        170.0
      ],
      "bbox_max": [
        834.24267578125,
        1109.7147216796875,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        1006.109130859375,
        170.0
      ],
      "bbox_max": [
        822.5736083984375,
        1069.2847900390625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 169.99998474121094,
      "bbox_min": [
        796.0811157226562,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        885.0,
        1016.168212890625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        865.0,
        905.9572143554688,
        69.44444274902344
      ],
      "bbox_max": [
        1030.0,
        1031.2564697265625,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1017.9999389648438,
        905.9572143554688,
        80.0
      ],
      "bbox_max": [
        1030.0,
        975.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1017.9999389648438,
        926.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        975.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        1030.0,
        975.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1017.9999389648438,
        926.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1017.9999389648438,
        905.9572143554688,
        80.0
      ],
      "bbox_max": [
        1030.0,
        926.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        865.0,
        910.5136108398438,
        69.44444274902344
      ],
      "bbox_max": [
        1030.0,
        1027.4595947265625,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1006.0,
        910.5136108398438,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1027.4595947265625,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1006.0,
        926.0,
        80.0
      ],
      "bbox_max": [
        1017.9999389648438,
        961.9999389648438,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        926.0,
        80.0
      ],
      "bbox_max": [
        1017.9999389648438,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1006.0,
        926.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        961.9999389648438,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1006.0,
        957.9999389648438,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1027.4595947265625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1027.4595947265625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1006.0,
        957.9999389648438,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1023.66259765625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1006.0,
        910.5136108398438,
        80.0
      ],
      "bbox_max": [
        1017.9999389648438,
        926.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        865.0,
        915.0699462890625,
        69.44444274902344
      ],
      "bbox_max": [
        1008.2842407226562,
        1022.143798828125,
        308.9880065917969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        914.0048217773438,
        915.0699462890625,
        74.8894271850586
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        308.9880065917969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        914.0048217773438,
        915.0699462890625,
        74.8894271850586
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        914.0048217773438,
        915.0699462890625,
        74.8894271850586
      ],
      "bbox_max": [
        1006.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        961.8380126953125,
        931.8380126953125,
        118.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        980.0,
        935.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        865.0,
        950.0,
        69.44444274902344
      ],
      "bbox_max": [
        1006.0,
        1022.143798828125,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        868.6691284179688,
        970.0,
        80.0
      ],
      "bbox_max": [
        1006.0,
        1022.143798828125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1006.0,
        1022.143798828125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1019.8656616210938,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        976.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        865.0,
        950.0,
        69.44444274902344
      ],
      "bbox_max": [
        1006.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        950.0,
        80.0
      ],
      "bbox_max": [
        1006.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        980.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        765.5892944335938,
        990.3442993164062,
        60.0
      ],
      "bbox_max": [
        807.7501831054688,
        1045.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        990.3442993164062,
        110.0
      ],
      "bbox_max": [
        807.7501831054688,
        1045.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        765.5892944335938,
        1000.8809204101562,
        60.0
      ],
      "bbox_max": [
        780.0,
        1038.243896484375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        684.064208984375,
        559.9999389648438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1006.3526000976562,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        730.0,
        559.9999389648438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1006.3526000976562,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        730.0,
        559.9999389648438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        760.0,
        559.9999389648438,
        140.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        760.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 707.730224609375,
      "bbox_min": [
        854.0377807617188,
        600.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        707.730224609375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        750.0,
        140.0
      ],
      "bbox_max": [
        914.0048828125,
        950.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        559.9999389648438,
        170.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        559.9999389648438,
        170.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        870.0000610351562,
        559.9999389648438,
        170.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        870.0000610351562,
        579.9998779296875,
        250.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.61072540283203,
      "bbox_min": [
        730.0,
        600.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -59.999996185302734,
      "bbox_min": [
        820.471435546875,
        600.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        901.9790649414062,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        830.0,
        600.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        901.9790649414062,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        901.9790649414062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 707.730224609375,
      "bbox_min": [
        836.5947875976562,
        600.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        707.730224609375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        837.443359375,
        610.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        680.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        850.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        660.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        990.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        990.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        950.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        650.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        610.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        730.0,
        672.556640625,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        830.0000610351562,
        672.556640625,
        80.98199462890625
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8724365234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 707.730224609375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        901.8654174804688,
        720.1305541992188,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        866.4380493164062,
        720.11572265625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        720.1305541992188,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 707.730224609375,
      "bbox_min": [
        830.0000610351562,
        672.556640625,
        80.98199462890625
      ],
      "bbox_max": [
        884.0368041992188,
        707.730224609375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        830.0000610351562,
        672.556640625,
        98.0
      ],
      "bbox_max": [
        844.216552734375,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        830.0000610351562,
        673.4052734375,
        98.0
      ],
      "bbox_max": [
        842.5957641601562,
        680.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        730.0,
        689.5284423828125,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        760.0,
        689.5284423828125,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.07647191733121872,
        -0.07647191733121872,
        0.9941348433494568
      ],
      "plane_d": 57.353939056396484,
      "bbox_min": [
        760.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        984.2857666015625,
        87.69231414794922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        910.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        930.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        966.6787109375,
        984.2857666015625,
        83.1792984008789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        966.6787109375,
        932.535888671875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        861.3308715820312,
        984.2857666015625,
        83.1792984008789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        984.2857666015625,
        77.729736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        711.7157592773438,
        60.0
      ],
      "bbox_max": [
        1014.179931640625,
        980.4865112304688,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        720.1305541992188,
        60.0
      ],
      "bbox_max": [
        1014.179931640625,
        980.4865112304688,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        760.0,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        961.8380126953125,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        836.568603515625,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        836.568603515625,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        866.4380493164062,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        961.8380126953125,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        960.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        961.8380126953125,
        931.8380126953125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        980.4865112304688,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        930.0,
        76.92308044433594
      ],
      "bbox_max": [
        861.3308715820312,
        973.5714111328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        820.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        820.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        730.0,
        749.9998779296875,
        60.0
      ],
      "bbox_max": [
        760.0,
        984.2857666015625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        735.6064453125,
        750.0000610351562,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        735.6064453125,
        940.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        753.6812744140625,
        973.5714111328125,
        60.0
      ],
      "bbox_max": [
        851.9248657226562,
        1006.3526000976562,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        753.6812744140625,
        979.9999389648438,
        60.0
      ],
      "bbox_max": [
        780.0,
        1006.3526000976562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        753.6812744140625,
        979.9999389648438,
        80.0
      ],
      "bbox_max": [
        760.0,
        993.9834594726562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -239.99998474121094,
      "bbox_min": [
        684.064208984375,
        790.0000610351562,
        240.0
      ],
      "bbox_max": [
        720.0,
        850.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        420.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        852.8232421875,
        1346.4150390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        490.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        852.8232421875,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1041.290771484375,
        60.0
      ],
      "bbox_max": [
        852.8232421875,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        582.7122802734375,
        1041.290771484375,
        60.0
      ],
      "bbox_max": [
        852.8232421875,
        1252.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1041.290771484375,
        60.0
      ],
      "bbox_max": [
        852.8232421875,
        1252.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        140.0
      ],
      "bbox_max": [
        852.8232421875,
        1252.0,
        535.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        -0.8660252690315247,
        -0.0
      ],
      "plane_d": 1452.3023681640625,
      "bbox_min": [
        805.3590087890625,
        1192.0,
        140.0
      ],
      "bbox_max": [
        852.8232421875,
        1212.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        840.0,
        1192.0,
        140.0
      ],
      "bbox_max": [
        852.8232421875,
        1199.403564453125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 647.2877197265625,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        647.2877197265625,
        1200.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6250033378601074,
        -0.7806220650672913
      ],
      "plane_d": -331.975830078125,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 643.2876586914062,
      "bbox_min": [
        643.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        706.0318603515625,
        1041.290771484375,
        60.0
      ],
      "bbox_max": [
        816.943115234375,
        1140.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        1041.290771484375,
        110.0
      ],
      "bbox_max": [
        816.943115234375,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        1071.3526611328125,
        78.0
      ],
      "bbox_max": [
        740.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        706.0318603515625,
        1085.8834228515625,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        706.0318603515625,
        1085.8834228515625,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        490.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        781.3767700195312,
        1221.862548828125,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        490.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        781.3767700195312,
        1221.862548828125,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        490.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        781.3767700195312,
        1221.862548828125,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        700.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        781.3767700195312,
        1096.0318603515625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1038.243896484375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1042.291015625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1038.243896484375,
        80.0
      ],
      "bbox_max": [
        781.3767700195312,
        1042.291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        1038.243896484375,
        110.0
      ],
      "bbox_max": [
        781.3767700195312,
        1042.291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        700.0,
        1000.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1096.0318603515625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        510.00006103515625,
        980.0,
        60.0
      ],
      "bbox_max": [
        762.71875,
        1000.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        730.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        762.71875,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        740.0,
        980.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        980.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1000.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        510.00006103515625,
        980.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        530.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        753.6813354492188,
        980.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        530.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        753.6813354492188,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        730.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        753.6813354492188,
        980.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        530.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        753.6812744140625,
        980.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        530.0,
        825.935791015625,
        60.0
      ],
      "bbox_max": [
        753.6812744140625,
        980.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        531.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        570.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        589.0000610351562,
        920.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        921.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        580.0,
        921.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        595.0659790039062,
        825.935791015625,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        595.0659790039062,
        825.935791015625,
        80.0
      ],
      "bbox_max": [
        694.9381103515625,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        595.0659790039062,
        825.935791015625,
        240.0
      ],
      "bbox_max": [
        694.9381103515625,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        420.0,
        1070.0,
        79.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        490.0,
        1221.862548828125,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        420.0,
        1070.0,
        79.0
      ],
      "bbox_max": [
        440.0,
        1181.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        420.0,
        1080.5,
        79.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        420.0,
        1070.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1181.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        429.5,
        1080.5,
        120.0
      ],
      "bbox_max": [
        429.5,
        1162.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        420.0,
        -2850.0,
        -300.0
      ],
      "bbox_max": [
        2754.851318359375,
        1090.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052745044231414795,
        0.6877359747886658,
        0.7240423560142517
      ],
      "plane_d": 740.0003051757812,
      "bbox_min": [
        420.0,
        -2850.0,
        60.0
      ],
      "bbox_max": [
        2400.0,
        1090.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        420.0,
        -2421.25,
        204.23513793945312
      ],
      "bbox_max": [
        2400.0,
        -1161.2073974609375,
        1308.39501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        650.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.8843994140625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.8843994140625,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        420.0,
        -1918.4615478515625,
        204.23513793945312
      ],
      "bbox_max": [
        2400.0,
        -1161.2073974609375,
        641.8307495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        420.0,
        -1600.0,
        204.23513793945312
      ],
      "bbox_max": [
        650.0,
        -1556.2850341796875,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        420.0,
        -1918.4615478515625,
        206.8179931640625
      ],
      "bbox_max": [
        650.0,
        -1558.4227294921875,
        641.8307495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        420.0,
        -1165.082275390625,
        60.0
      ],
      "bbox_max": [
        2400.0,
        1090.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        420.0,
        -1165.082275390625,
        60.0
      ],
      "bbox_max": [
        2400.0,
        920.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        1114.72705078125,
        920.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        220.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        220.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.38636779785156,
      "bbox_min": [
        630.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        870.0,
        770.0001220703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        630.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        870.0,
        676.5650024414062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        870.0,
        676.5650024414062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 268.32818603515625,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        314.0712890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 299.9999694824219,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        314.0712890625,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 856.760986328125,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        314.0712890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 304.0712890625,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        304.0712890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        796.8701171875,
        640.0,
        98.0
      ],
      "bbox_max": [
        850.0,
        676.5650024414062,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        816.8701171875,
        660.0,
        98.0
      ],
      "bbox_max": [
        850.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        630.0,
        324.60308837890625,
        80.0
      ],
      "bbox_max": [
        650.0,
        505.85784912109375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        630.0,
        485.8578186035156,
        60.0
      ],
      "bbox_max": [
        833.43505859375,
        770.0001220703125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        660.0,
        501.7156982421875,
        80.0
      ],
      "bbox_max": [
        833.43505859375,
        680.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        501.7156982421875,
        98.0
      ],
      "bbox_max": [
        818.2843017578125,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        805.0,
        660.0,
        98.0
      ],
      "bbox_max": [
        818.2843017578125,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        503.1299133300781,
        80.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        630.0,
        485.8578186035156,
        60.0
      ],
      "bbox_max": [
        824.1422119140625,
        770.0001220703125,
        100.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        630.0,
        487.2720642089844,
        60.0
      ],
      "bbox_max": [
        770.0,
        770.0001220703125,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        687.3342895507812,
        588.12109375,
        78.0
      ],
      "bbox_max": [
        770.0,
        689.9500122070312,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3629886209964752,
        -0.3629886209964752,
        -0.8581832647323608
      ],
      "plane_d": 534.1971435546875,
      "bbox_min": [
        687.3342895507812,
        588.12109375,
        78.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        687.3342895507812,
        595.192138671875,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        630.0,
        566.14208984375,
        78.0
      ],
      "bbox_max": [
        740.0,
        770.0001220703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 910.2266845703125,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        740.0,
        770.0001220703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        740.0,
        770.0001220703125,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 704.1422119140625,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        740.0,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        689.9500122070312,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        630.0,
        540.836669921875,
        80.0
      ],
      "bbox_max": [
        824.1422119140625,
        750.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7072827219963074,
        -0.7069308161735535,
        0.0
      ],
      "plane_d": 866.8078002929688,
      "bbox_min": [
        670.7326049804688,
        540.836669921875,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        668.2536010742188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        770.0000610351562,
        654.1421508789062,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        668.2536010742188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 784.1422119140625,
      "bbox_min": [
        784.1422119140625,
        660.0,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        668.2536010742188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        630.0,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        750.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 784.1422119140625,
      "bbox_min": [
        658.9852905273438,
        566.8431396484375,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        658.9852905273438,
        566.8431396484375,
        98.0
      ],
      "bbox_max": [
        675.4915771484375,
        576.2783813476562,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        658.9852905273438,
        566.8431396484375,
        98.0
      ],
      "bbox_max": [
        668.4205322265625,
        576.2783813476562,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        630.0,
        566.8431396484375,
        80.0
      ],
      "bbox_max": [
        720.0,
        750.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        666.0563354492188,
        569.2073364257812,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        666.0563354492188,
        573.9141845703125,
        80.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        499.80194091796875,
        579.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        920.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        550.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        750.0,
        80.0
      ],
      "bbox_max": [
        630.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        620.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        630.0,
        750.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        595.0659790039062,
        914.9339599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        420.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        420.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        560.0,
        80.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        420.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        560.0,
        78.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        550.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        550.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        623.85791015625,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        566.14208984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        420.0,
        280.5788269042969,
        78.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        629.7952880859375,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 433.5480041503906,
      "bbox_min": [
        523.7213745117188,
        280.5788269042969,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        319.3297424316406,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312655448914,
        -0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": 588.2703247070312,
      "bbox_min": [
        455.27862548828125,
        452.5851135253906,
        78.0
      ],
      "bbox_max": [
        563.2279052734375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 433.5479736328125,
      "bbox_min": [
        523.0199584960938,
        480.6702575683594,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        523.7213745117188,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        523.0199584960938,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        500.0,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        481.1798095703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        480.0,
        481.1798095703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        480.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08444590121507645,
        -0.8904321193695068,
        0.4472130537033081
      ],
      "plane_d": 170.72767639160156,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        420.0,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        630.0,
        520.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8506506681442261,
        -0.2763928174972534,
        0.44721418619155884
      ],
      "plane_d": 568.5951538085938,
      "bbox_min": [
        514.7213745117188,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        579.4631958007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257311463356018,
        0.7236066460609436,
        0.44721370935440063
      ],
      "plane_d": 9.384859085083008,
      "bbox_min": [
        514.7213745117188,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 433.5480041503906,
      "bbox_min": [
        514.7213745117188,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        523.7213745117188,
        323.91546630859375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312655448914,
        -0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": 588.2703247070312,
      "bbox_min": [
        514.7213745117188,
        447.0228271484375,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 433.5479736328125,
      "bbox_min": [
        514.7213745117188,
        476.08453369140625,
        60.0
      ],
      "bbox_max": [
        523.7213745117188,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09441348165273666,
        -0.9955330491065979,
        0.0
      ],
      "plane_d": 230.879150390625,
      "bbox_min": [
        420.0,
        281.67816162109375,
        80.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        455.2785949707031,
        281.67816162109375,
        80.0
      ],
      "bbox_max": [
        580.5146484375,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        455.2785949707031,
        281.67816162109375,
        80.0
      ],
      "bbox_max": [
        563.2279052734375,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        281.67816162109375,
        80.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        -0.8090171217918396,
        0.0
      ],
      "plane_d": 697.7061157226562,
      "bbox_min": [
        455.2785949707031,
        453.2031555175781,
        80.0
      ],
      "bbox_max": [
        563.2279052734375,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        498.8174743652344,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        498.8174743652344,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": 396.11688232421875,
      "bbox_min": [
        514.7213745117188,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        455.2785949707031,
        495.0,
        87.5
      ],
      "bbox_max": [
        505.6994934082031,
        500.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        500.0,
        95.5
      ],
      "bbox_max": [
        498.8174743652344,
        500.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        500.0,
        87.5
      ],
      "bbox_max": [
        465.2785949707031,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        420.0,
        275.0924072265625,
        100.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        420.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        420.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09441348165273666,
        -0.9955330491065979,
        0.0
      ],
      "plane_d": 230.879150390625,
      "bbox_min": [
        420.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        866.760986328125,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        420.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        516.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        280.0,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        510.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        -0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        480.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        559.7213745117188,
        313.1678466796875,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        500.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 856.760986328125,
      "bbox_min": [
        856.760986328125,
        313.1678466796875,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        314.0712890625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": 428.49554443359375,
      "bbox_min": [
        480.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        480.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        563.2279052734375,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        480.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        480.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        500.0,
        280.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        481.1797790527344,
        140.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        500.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        510.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        140.0
      ],
      "bbox_max": [
        600.0,
        508.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        600.0,
        500.0,
        140.0
      ],
      "bbox_max": [
        600.0,
        508.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        510.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        516.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 304.0712890625,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        140.0
      ],
      "bbox_max": [
        866.760986328125,
        313.1678466796875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 856.760986328125,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        140.0
      ],
      "bbox_max": [
        856.760986328125,
        313.1678466796875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        420.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        920.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        140.0
      ],
      "bbox_max": [
        595.0659790039062,
        920.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        140.0
      ],
      "bbox_max": [
        595.0659790039062,
        914.9339599609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        420.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        750.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        420.0,
        580.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        750.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 430.0,
      "bbox_min": [
        420.0,
        580.0,
        140.0
      ],
      "bbox_max": [
        760.0,
        750.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        760.0,
        750.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        420.0,
        580.0,
        160.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        420.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        715.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        580.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        525.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        870.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        525.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        420.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        866.760986328125,
        920.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 856.760986328125,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        100.0
      ],
      "bbox_max": [
        866.760986328125,
        314.0712890625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 304.0712890625,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        100.0
      ],
      "bbox_max": [
        866.760986328125,
        304.0712890625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        420.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09441348165273666,
        -0.9955330491065979,
        0.0
      ],
      "plane_d": 230.879150390625,
      "bbox_min": [
        480.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        620.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": 428.49554443359375,
      "bbox_min": [
        480.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        580.5146484375,
        460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        -0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        480.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        580.5146484375,
        460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        280.0,
        100.0
      ],
      "bbox_max": [
        580.5146484375,
        460.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        480.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        563.2279052734375,
        460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        480.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        480.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        280.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.951056718826294,
        -0.30901670455932617,
        0.0
      ],
      "plane_d": 655.7090454101562,
      "bbox_min": [
        518.2229614257812,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        563.2279052734375,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        -0.8090171217918396,
        0.0
      ],
      "plane_d": 697.7061157226562,
      "bbox_min": [
        553.8728637695312,
        453.2031555175781,
        118.0
      ],
      "bbox_max": [
        563.2279052734375,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056718826294,
        0.30901670455932617,
        0.0
      ],
      "plane_d": 408.4956970214844,
      "bbox_min": [
        518.2229614257812,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        559.4854125976562,
        400.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877847671508789,
        0.8090173602104187,
        0.0
      ],
      "plane_d": 30.49212646484375,
      "bbox_min": [
        518.2229614257812,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        546.2149047851562,
        359.15753173828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        524.7213745117188,
        281.67816162109375,
        100.0
      ],
      "bbox_max": [
        563.2279052734375,
        460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        281.67816162109375,
        100.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        -0.8090171217918396,
        0.0
      ],
      "plane_d": 697.7061157226562,
      "bbox_min": [
        553.8728637695312,
        453.2031555175781,
        100.0
      ],
      "bbox_max": [
        563.2279052734375,
        460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        420.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        798.2843627929688,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        100.0
      ],
      "bbox_max": [
        595.0659790039062,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        100.0
      ],
      "bbox_max": [
        595.0659790039062,
        914.9339599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        420.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        798.2843627929688,
        750.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        798.2843627929688,
        750.0001220703125,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1053.589111328125,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        788.2843017578125,
        750.0001220703125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        730.0,
        118.0
      ],
      "bbox_max": [
        770.0,
        750.0001220703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        118.0
      ],
      "bbox_max": [
        770.0,
        750.0001220703125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        420.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        -0.8090171217918396,
        0.0
      ],
      "plane_d": 697.7061157226562,
      "bbox_min": [
        518.2229614257812,
        460.0,
        100.0
      ],
      "bbox_max": [
        600.0,
        500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        481.1797790527344,
        100.0
      ],
      "bbox_max": [
        600.0,
        500.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        600.0,
        485.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        518.2229614257812,
        460.0,
        118.0
      ],
      "bbox_max": [
        553.8728637695312,
        481.1797790527344,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        500.0,
        100.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        580.0,
        500.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        580.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        420.0,
        275.0924072265625,
        190.0
      ],
      "bbox_max": [
        840.0,
        920.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        190.0
      ],
      "bbox_max": [
        595.0659790039062,
        920.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        190.0
      ],
      "bbox_max": [
        595.0659790039062,
        914.9339599609375,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        420.0,
        275.0924072265625,
        190.0
      ],
      "bbox_max": [
        840.0,
        750.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 430.0,
      "bbox_min": [
        420.0,
        580.0,
        190.0
      ],
      "bbox_max": [
        760.0,
        750.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        190.0
      ],
      "bbox_max": [
        760.0,
        750.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        420.0,
        650.0,
        190.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09441348165273666,
        -0.9955330491065979,
        0.0
      ],
      "plane_d": 230.879150390625,
      "bbox_min": [
        420.0,
        275.0924072265625,
        190.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        420.0,
        275.0924072265625,
        190.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        190.0
      ],
      "bbox_max": [
        580.5146484375,
        510.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": 428.49554443359375,
      "bbox_min": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "bbox_max": [
        580.5146484375,
        453.2031555175781,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        -0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "bbox_max": [
        580.5146484375,
        453.2031555175781,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "bbox_max": [
        563.2279052734375,
        346.7968444824219,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        281.6781921386719,
        190.0
      ],
      "bbox_max": [
        580.5146484375,
        510.0,
        215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": 428.49554443359375,
      "bbox_min": [
        524.7213745117188,
        281.6781921386719,
        190.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        -0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        524.7213745117188,
        281.6781921386719,
        190.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        524.7213745117188,
        281.6781921386719,
        190.0
      ],
      "bbox_max": [
        563.2279052734375,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        281.6781921386719,
        190.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        481.1797790527344,
        190.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        524.7213745117188,
        500.0,
        190.0
      ],
      "bbox_max": [
        524.7213745117188,
        510.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        420.0,
        -1165.082275390625,
        220.0
      ],
      "bbox_max": [
        2400.0,
        920.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        420.0,
        -1165.082275390625,
        220.0
      ],
      "bbox_max": [
        2400.0,
        869.8349609375,
        460.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        420.0,
        580.0,
        220.0
      ],
      "bbox_max": [
        669.802001953125,
        750.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        420.0,
        650.0,
        220.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        840.0,
        579.802001953125,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        420.0,
        -1165.082275390625,
        240.0
      ],
      "bbox_max": [
        2400.0,
        799.9862060546875,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.597613875987008e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9581909179688,
      "bbox_min": [
        420.0,
        749.9900512695312,
        240.0
      ],
      "bbox_max": [
        499.9962463378906,
        784.537353515625,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        420.0,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        499.9961853027344,
        784.537353515625,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5712229013442993,
        -0.8207949995994568,
        0.0
      ],
      "plane_d": 901.202392578125,
      "bbox_min": [
        450.3636474609375,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        499.9961853027344,
        784.537353515625,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        499.9962463378906,
        -1165.082275390625,
        240.0
      ],
      "bbox_max": [
        2400.0,
        750.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        499.9962463378906,
        500.0,
        240.0
      ],
      "bbox_max": [
        840.0,
        750.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        499.9962463378906,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        550.0,
        750.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        499.9962463378906,
        -1165.082275390625,
        250.0
      ],
      "bbox_max": [
        2400.0,
        750.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        2356.415771484375,
        -1165.082275390625,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        259.4555358886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        549.9669799804688,
        500.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        914.9339599609375,
        288.0650634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -239.99998474121094,
      "bbox_min": [
        549.9669799804688,
        500.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        914.9339599609375,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        559.9999389648438,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        764.2857055664062,
        750.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        764.2857055664062,
        500.0,
        240.0
      ],
      "bbox_max": [
        950.0,
        745.7142944335938,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        766.4285888671875,
        716.5686645507812,
        250.0
      ],
      "bbox_max": [
        774.5853881835938,
        743.5714111328125,
        288.0650634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        420.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        590.0000610351562,
        1090.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        420.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        580.0,
        1090.0,
        340.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        420.0,
        980.0,
        76.0
      ],
      "bbox_max": [
        529.9999389648438,
        1090.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        420.0,
        985.0,
        76.0
      ],
      "bbox_max": [
        429.5,
        985.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        145.0
      ],
      "bbox_max": [
        490.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        145.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        420.0,
        980.0,
        79.0
      ],
      "bbox_max": [
        490.0,
        1080.5,
        145.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        420.0,
        985.0,
        79.0
      ],
      "bbox_max": [
        429.5,
        985.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        429.5,
        980.0,
        120.0
      ],
      "bbox_max": [
        490.0,
        1070.0,
        145.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        490.0,
        1000.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        429.5,
        985.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        996.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 995.0,
      "bbox_min": [
        429.5,
        995.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        996.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -996.0,
      "bbox_min": [
        429.5,
        995.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        996.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 438.0,
      "bbox_min": [
        431.0,
        995.0,
        120.0
      ],
      "bbox_max": [
        438.0,
        996.0,
        132.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.5,
      "bbox_min": [
        431.0,
        995.0,
        132.5
      ],
      "bbox_max": [
        438.0,
        996.0,
        132.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        420.0,
        985.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        985.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        490.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        529.9999389648438,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        490.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        529.9999389648438,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        490.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        529.9999389648438,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        420.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        580.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        420.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        570.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        420.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        570.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        420.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        570.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        420.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        531.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        420.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        540.0000610351562,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        420.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        420.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        420.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        420.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        960.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        420.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        580.0,
        940.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        370.0,
        1090.0,
        76.0
      ],
      "bbox_max": [
        420.0,
        1181.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -1201.24462890625,
        -2950.0,
        -300.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        1702.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9245350956916809,
        0.2898501753807068,
        0.24743026494979858
      ],
      "plane_d": -524.6070556640625,
      "bbox_min": [
        -1201.24462890625,
        -2950.0,
        0.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        1702.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1062.5450439453125,
        -2563.9130859375,
        0.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        1443.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -551.24462890625,
        -2563.9130859375,
        0.0
      ],
      "bbox_max": [
        420.0,
        -1371.68505859375,
        1443.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2563.9130859375,
        641.8307495117188
      ],
      "bbox_max": [
        420.0,
        -1918.4615478515625,
        1443.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052745044231414795,
        0.6877359747886658,
        0.7240423560142517
      ],
      "plane_d": 740.0003051757812,
      "bbox_min": [
        0.0,
        -2563.9130859375,
        1308.39501953125
      ],
      "bbox_max": [
        420.0,
        -2421.25,
        1443.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1062.5450439453125,
        -2050.0,
        0.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -160.0,
        230.86279296875,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09006218612194061,
        -0.9959362149238586,
        0.0
      ],
      "plane_d": 221.38485717773438,
      "bbox_min": [
        -160.0,
        230.86279296875,
        60.0
      ],
      "bbox_max": [
        310.0,
        1050.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        -160.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1050.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        260.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -160.0,
        830.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -160.0,
        830.0,
        144.0
      ],
      "bbox_max": [
        -100.0,
        830.0,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        112.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        -160.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1050.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        980.0,
        155.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -160.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        260.0,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        300.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        300.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        310.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        310.0,
        250.32139587402344,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        310.0,
        255.06324768066406,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 359.9999694824219,
      "bbox_min": [
        349.9999694824219,
        255.06324768066406,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        200.00009155273438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        359.9999694824219,
        344.45166015625,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        200.00009155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        359.9999694824219,
        510.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        100.0000228881836
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        359.9999694824219,
        510.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        370.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        360.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        370.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        359.9999694824219,
        510.0,
        78.0
      ],
      "bbox_max": [
        370.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        359.9999694824219,
        560.0,
        78.0
      ],
      "bbox_max": [
        370.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        360.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        370.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        359.9999694824219,
        511.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        359.9999694824219,
        921.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        921.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        930.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        360.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        370.0,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        359.9999694824219,
        510.0,
        80.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        100.0000228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        370.0,
        580.0,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        370.0,
        580.0,
        100.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 820.2513427734375,
      "bbox_min": [
        359.9999694824219,
        790.0107421875,
        80.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        100.0000228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        359.9999694824219,
        920.0,
        80.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        100.0000228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        359.9999694824219,
        980.0,
        80.0
      ],
      "bbox_max": [
        370.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        369.9999694824219,
        344.45166015625,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        200.00009155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        370.0,
        344.45166015625,
        60.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        79.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        370.0,
        510.5,
        78.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        370.0,
        920.5,
        78.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        78.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        370.0,
        920.5,
        78.0
      ],
      "bbox_max": [
        420.0,
        940.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        370.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        420.0,
        940.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        370.0,
        510.5,
        78.0
      ],
      "bbox_max": [
        420.0,
        560.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        370.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        420.0,
        560.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        370.0,
        510.5,
        78.0
      ],
      "bbox_max": [
        420.0,
        511.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        370.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        370.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        420.0,
        579.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        370.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        420.0,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        370.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        76.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        369.9999694824219,
        344.45166015625,
        79.0
      ],
      "bbox_max": [
        420.0,
        1117.5,
        200.00009155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        392.4999694824219,
        510.0,
        145.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        200.00009155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        392.4999694824219,
        510.0,
        145.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        392.4999694824219,
        732.4678955078125,
        145.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        392.4999694824219,
        732.4678955078125,
        145.0
      ],
      "bbox_max": [
        410.0213928222656,
        767.5107421875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 820.2513427734375,
      "bbox_min": [
        392.4999694824219,
        749.9893188476562,
        145.0
      ],
      "bbox_max": [
        410.0213928222656,
        767.5107421875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        392.4999694824219,
        980.0,
        145.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        392.4999694824219,
        510.0,
        145.0
      ],
      "bbox_max": [
        420.0,
        510.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        399.9999694824219,
        510.0,
        160.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        200.00009155273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        399.9999694824219,
        510.0,
        160.0
      ],
      "bbox_max": [
        420.0,
        760.0107421875,
        200.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        399.9999694824219,
        739.9678955078125,
        160.0
      ],
      "bbox_max": [
        410.0213928222656,
        760.0107421875,
        180.0428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 820.2513427734375,
      "bbox_min": [
        399.9999694824219,
        749.9893188476562,
        160.0
      ],
      "bbox_max": [
        410.0213928222656,
        760.0107421875,
        180.0428466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        399.9999694824219,
        510.0,
        160.0
      ],
      "bbox_max": [
        420.0,
        510.0,
        200.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        399.9999694824219,
        980.0,
        160.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        200.0000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        369.9999694824219,
        344.45166015625,
        79.0
      ],
      "bbox_max": [
        420.0,
        1007.0,
        145.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        370.0,
        510.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        370.0,
        920.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        985.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        370.0,
        920.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        370.0,
        940.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        370.0,
        510.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        370.0,
        560.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        370.0,
        510.0,
        79.0
      ],
      "bbox_max": [
        420.0,
        510.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 820.2513427734375,
      "bbox_min": [
        369.9999694824219,
        510.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1007.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        369.9999694824219,
        920.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1007.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        369.9999694824219,
        960.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1007.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        369.9999694824219,
        960.0,
        100.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        369.9999694824219,
        960.0,
        100.0
      ],
      "bbox_max": [
        420.0,
        960.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        379.9999694824219,
        980.0,
        120.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        369.9999694824219,
        980.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        379.9999694824219,
        985.0,
        120.0
      ],
      "bbox_max": [
        420.0,
        1007.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        370.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        370.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        370.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        580.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        349.9999694824219,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.00001525878906
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        358.9999694824219,
        730.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        359.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        730.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        358.9999694824219,
        979.0,
        78.0
      ],
      "bbox_max": [
        359.9999694824219,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        358.9999694824219,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        560.0,
        80.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        359.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        349.9999694824219,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        921.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        350.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        434.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        356.4999694824219,
        422.0,
        73.0
      ],
      "bbox_max": [
        360.0,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        356.4999694824219,
        422.0,
        73.0
      ],
      "bbox_max": [
        360.0,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -434.0,
      "bbox_min": [
        356.4999694824219,
        434.0,
        73.0
      ],
      "bbox_max": [
        360.0,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        310.0,
        266.0564880371094,
        60.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        359.9999694824219,
        266.0564880371094,
        80.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        7.597613875987008e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9581909179688,
      "bbox_min": [
        410.0213928222656,
        740.0106201171875,
        240.0
      ],
      "bbox_max": [
        420.0,
        749.9900512695312,
        360.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        410.0213928222656,
        740.0106201171875,
        240.0
      ],
      "bbox_max": [
        420.0,
        749.9900512695312,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        360.0,
        266.0564880371094,
        80.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        399.9999694824219,
        580.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        360.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        420.0,
        650.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        360.0,
        650.0,
        220.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        360.0,
        650.0,
        220.0
      ],
      "bbox_max": [
        420.0,
        749.9893188476562,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        360.0,
        650.0,
        220.0
      ],
      "bbox_max": [
        420.0,
        650.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        359.9999694824219,
        960.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1140.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        370.0,
        985.0,
        100.00006103515625
      ],
      "bbox_max": [
        392.4999694824219,
        1140.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        370.0,
        985.0,
        100.00006103515625
      ],
      "bbox_max": [
        392.4999694824219,
        1140.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        100.00006103515625
      ],
      "bbox_max": [
        392.4999694824219,
        1007.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        370.0,
        985.0,
        120.0
      ],
      "bbox_max": [
        379.9999694824219,
        1007.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        379.9999694824219,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        372.4999694824219,
        980.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        372.4999694824219,
        960.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        310.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        340.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        310.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.00001525878906
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.00001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        340.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        340.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        540.0,
        80.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        340.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        280.0,
        80.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        340.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        359.9999694824219,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        340.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        340.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        730.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.00000762939453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        380.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        280.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 199.6920928955078,
      "bbox_min": [
        310.0,
        477.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        310.0,
        477.0,
        78.0
      ],
      "bbox_max": [
        320.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        320.0,
        477.0,
        78.0
      ],
      "bbox_max": [
        320.0,
        480.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        320.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        320.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        330.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        330.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        540.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        330.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        380.0,
        80.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 380.0,
      "bbox_min": [
        330.0,
        380.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        380.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        330.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        330.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        330.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        330.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        730.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        330.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        359.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -931.9000244140625,
      "bbox_min": [
        310.0,
        931.9000244140625,
        63.950008392333984
      ],
      "bbox_max": [
        320.0,
        931.9000244140625,
        64.86666107177734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -931.9000244140625,
      "bbox_min": [
        310.0,
        931.9000244140625,
        60.0
      ],
      "bbox_max": [
        320.0,
        931.9000244140625,
        63.950008392333984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 199.6920928955078,
      "bbox_min": [
        320.0,
        422.0,
        60.0
      ],
      "bbox_max": [
        357.4999694824219,
        480.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        320.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        320.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -458.5,
      "bbox_min": [
        320.0,
        458.5,
        63.666656494140625
      ],
      "bbox_max": [
        330.0,
        458.5,
        65.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -458.5,
      "bbox_min": [
        320.0,
        458.5,
        60.0
      ],
      "bbox_max": [
        330.0,
        458.5,
        63.666656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        355.0,
        422.0,
        73.0
      ],
      "bbox_max": [
        357.4999694824219,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 355.0,
      "bbox_min": [
        355.0,
        422.0,
        73.0
      ],
      "bbox_max": [
        357.4999694824219,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        355.0,
        422.0,
        73.0
      ],
      "bbox_max": [
        357.4999694824219,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 422.0,
      "bbox_min": [
        355.0,
        422.0,
        73.0
      ],
      "bbox_max": [
        357.4999694824219,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -434.0,
      "bbox_min": [
        355.0,
        434.0,
        73.0
      ],
      "bbox_max": [
        357.4999694824219,
        434.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        280.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        310.0,
        280.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        460.0,
        90.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -92.0,
      "bbox_min": [
        310.0,
        460.0,
        90.0
      ],
      "bbox_max": [
        315.0,
        470.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        310.0,
        460.0,
        90.0
      ],
      "bbox_max": [
        315.0,
        470.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        310.0,
        460.0,
        90.0
      ],
      "bbox_max": [
        315.0,
        470.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        310.0,
        460.0,
        90.0
      ],
      "bbox_max": [
        315.0,
        470.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        310.0,
        470.0,
        90.0
      ],
      "bbox_max": [
        315.0,
        470.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -1100.0,
        -1643.6373291015625,
        0.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 925.178466796875,
      "bbox_min": [
        -1100.0,
        -1643.6373291015625,
        0.0
      ],
      "bbox_max": [
        -339.5,
        1115.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1100.0,
        -1643.6373291015625,
        0.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903998374939,
        -0.5592629313468933,
        -9.561446495354176e-05
      ],
      "plane_d": 306.83837890625,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -339.5,
        1075.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        -500.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        -500.0,
        700.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        911.17822265625,
        120.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 363.12860107421875,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        225.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        250.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "C:\\editor\\working\\n_q301.lwo",
      "entity_class": "C:\\editor\\working\\n_q301.lwo",
      "piece_name": "",
      "offset": 2188,
      "centroid": [
        480.0,
        808.0,
        466.0
      ],
      "bbox_min": [
        410.0,
        400.0,
        -5.0
      ],
      "bbox_max": [
        630.0,
        1100.0,
        1045.0
      ],
      "dimensions_source": {
        "span_x": 220.0,
        "span_y": 700.0,
        "height_z": 1050.0,
        "door_width": 700.0,
        "door_depth": 220.0,
        "leaf_depth": 220.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          420.0,
          670.0,
          -5.0
        ],
        [
          420.0,
          670.0,
          1045.0
        ],
        [
          420.0,
          400.0,
          1045.0
        ],
        [
          420.0,
          400.0,
          -5.0
        ],
        [
          410.0,
          1100.0,
          1045.0
        ],
        [
          630.0,
          880.0,
          1045.0
        ],
        [
          410.0,
          1100.0,
          245.0
        ],
        [
          630.0,
          880.0,
          245.0
        ],
        [
          410.0,
          1100.0,
          0.0
        ],
        [
          630.0,
          880.0,
          0.0
        ]
      ],
      "plane_distance": 420.0
    }
  ],
  "tutorial_messages": []
}